export const locale = {
  general_menu_settings: 'General Menu Settings',
  settings: {
    
  business_type_title: 'Select Menu Business Type',
  currency_label: 'Currency',
  show_filter: 'Show Products Filter',
  show_categories: 'Show Products Categories',
  
  business_types: {
    cafe: 'Cafe',
    restaurant: 'Restaurant',
    fastfood: 'Fast Food',
    icecream: 'Juice & Ice Cream',
    sweets: 'Sweets & Desserts',
    bakery: 'Bakery'
  },
  
  custom_labels: {
    ph_menu_cafe: 'Cafe Menu',
    ph_menu_restaurant: 'Food Menu',
    ph_menu_fastfood: 'Fast Food Menu',
    ph_menu_icecream: 'Juice & Ice Cream',
    ph_menu_sweets: 'Cakes & Sweets',
    ph_menu_bakery: 'Breads & Bakery',
    ph_product_list: 'Products',
    ph_add_order: 'Add',
    ph_add_cart: 'Buy',
    title: 'Customize Labels (Optional)',
    subtitle: 'Replace default system terms with your own preferred words.',
    products_title: 'Products Section Title',
    ph_food_menu: 'Food Menu',
    ph_product_list: 'Product List',
    cart_btn: 'Checkout Button Text',
    ph_add_order: 'Add to Order',
    ph_add_cart: 'Add to Cart'
  },

  currencies: {
    toman: 'Toman',
    rial: 'Rial'
  }
},
check_account_balance_and_try_again: 'Please check your account balance and try again',
problem_with_qr_renewal_request: 'There was a problem with the QR code renewal request',

  ERRORS: {
    PhoneIsNotValid: "The entered phone number is invalid: e.g., 09101234567",
    InvalidNumber: "The entered quantity is invalid.",
    NoSelectedLineNumber: "Please select a sender line.",
    EmptyText: "Please enter the text.",
    UnknownError: "Unknown error",
    TryAgain: "Please try again later.",
    NoAccountCharge: "Insufficient balance",
    NoAccess: "Access denied.",
    PleasebyeAPlane: "Please purchase a plan.",
    PleaseChargeYourAccount: "Please top up your account.",
    AccessDenied: "Access denied.",
    AccessDeniedDescription: "Contact support for more information.",
    Error: "Error",
    InvalidText: "Invalid text",
    InvalidTextContainsLink: "Only service lines can contain links.",
    NoPhoneToSend: "There are no numbers to send to.",
  },
  FORMS: {
    SuccsessFullySended: "Got it",
    DestinationPhone: "Recipient phone number",
    TestDestinationPhone: "Test phone number",
    SourceNumber: "Sender number",
    Text: "Text",
    CharCount: "Character count",
    FarsiCharCount: "Persian character count",
    EnglishCharCount: "English character count",
    Send: "Send",
    SendTime: "Send time",
    SendTest: "Test send",
    SendToTestNumber: "Send to test number",
    SmsCount: "SMS count",
    SmsLang: "SMS language",
    Add: "Add",
    FromFile: "Add from file",
    TestNumber: "Test number",
    Test: "Test",
    ServiceRelated: "Service/Transactional",
    Price: "Whitelist send cost",
    TotalPrice: "Total cost",
    NumbersCount: "Total numbers count",
    BlacklistPrice: "Blacklist send cost",
    BlacklistNumbersCount: "Blacklist count",
    WhitelistNumbersCount: "Whitelist count",
    IrancellNumbersBlacklistCount: "Irancell blacklist count",
    HamrahavalNumbersBlacklistCount: "Hamrah Aval blacklist count",
    IrancellNumbersWhitelistCount: "Irancell whitelist count",
    HamrahavalNumbersWhitelistCount: "Hamrah Aval whitelist count",
    NumbersCountToSend: "Valid numbers count",
    Search: "Search",
    Title: "Title",
    RequestTime: "Request time",
    RequestInformation: "Request information",
    CreateNewPhoneBook: "Create new phonebook",
    AddPhone: "Add numbers",
    Remove: "Remove",
  },
  unexpected_error: "An unexpected error occurred. Please try again.",
  luck_wheel_name: "Lucky Wheel QR Name",
  update_video: "Add Video Gallery",
  edit: "Edit",
  to_top: "From top",
  to_bottom: "From bottom",
  to_left: "From right to left",
  to_right: "From left to right",
  to_top_right: "From bottom to right",
  to_top_left: "From bottom to left",
  to_bottom_right: "From top to right",
  to_bottom_left: "From top to left",
  select_color_gradient: "Select gradient colour",
  select_color_solid: "Select solid colour",
  gradient_direction: "Gradient direction",
  gradient_background: "Gradient background",
  qr_downloaded_successfully: "QR code downloaded successfully.",
  logo: "Logo",
  qr_design_size: "QR design and size",
  qr_eye_design: "QR eye design",
  qr_markout: "Output margin",
  frame: "Frame",
  ready_card_samples: "Ready business card samples",
  ready_card_sample: "Ready business card sample",
  remove_default_info: "Remove default information",
  select_ready_card: "Select ready card",
  connection_code: "Connection code",
  enter_visit_card_info: "Enter business card information",
  info: "Information",
  select_template_design: "Select template design",
  qr_address: "QR address",
  visit_card_name: "Your business card name",
  visit_card_name_pro: "Your Pro business card name",
  download_qr: "Download QR",
  fast_design: "Fast design",
  professional_design: "Professional design",
  ai_design: "AI design",
  update_qr: "Update QR",
  fast_design_message:
    "You have switched to fast code design. The previous design was completed in this section.",
  professional_design_message:
    "You have switched to professional code design. The previous design was completed in this section.",
  scan_me: "Scan me",
  visit_card_edited_successfully:
    "Your business card has been edited successfully.",
  customer_club_membership: "Customer club membership",
  qrland: "QR Land",
  dynamic: "Dynamic",
  about_us_text:
    "Dynamic QR code features:\n✔️ Unlimited editing\n✔️ Easy scanning\n✔️ Scan limit option\n✔️ Password addition\n✔️ View and analyse visitor statistics\n✔️ Change QR colour and appearance\n✔️ Data and security preservation\n✔️ Add image and logo to QR\n✔️ Specialised QR based on business needs\n✔️ Redirect scanner to links and site\n✔️ Provide QR and short link together\n✔️ Works on all social networks (offline/online)\n✔️ Downloadable in any format\n✔️ Printable on any surface or size",
  video_gallery: "Video gallery",
  address_text:
    "London, Oxford Street, after Oxford Circus, Khalidiya Lane, Unit 6",
  visit_card: "Business card",
  qrland_system: "QR Land system",
  qrland_first_system: "First dynamic QR code creation system",
  address: "Address",
  enter_site_link: "Enter the desired website link",
  instagram: "Instagram",
  enter_instagram_username: "Enter your username",
  whatsapp: "WhatsApp",
  invalid_qr_address: "The entered address is invalid!",
  visit_card_created_successfully:
    "Your business card has been created successfully.",
  qr_creation_failed: "QR creation failed!",
  manage_password: "Manage password",
  hour_limit: "Time limit",
  scan_click_limit: "Scan/click limit",
  redirect_scanner: "Redirect scanner",
  edit_settings_error: "An error occurred while editing settings!",
  next: "Next",
  add: "Add",
  header_color_settings: "Header colour and text settings",
  select_image: "Select image",
  enter_qr_address: "Enter your QR address",
  qr_idea_title: "QR creation idea",
  qr_idea: "QR idea",
  qr_idea_subject: "QR creation subject",
  confirm_qr_idea: "Confirm my QR idea",
  scannable: "Scannable",
  ai_sample: "AI-generated sample...",
  scan_warning: "May not scan on all devices. If it fails, try again.",
  ai_description:
    "Enter the desired QR description; AI will create it for you.",
  attach: "Attach",
  remaining: "Remaining",
  qr_creation: "QR creation",
  free: "Free",
  select_language_for_request: "Select language for request text",
  request_text: "Request text",
  request_text_placeholder: "Describe the desired QR link...",
  strengthen_text: "Strengthen current text",
  prompt_idea: "Prompt idea",
  try_again: "Try again",
  create_qr: "Create QR",
  smart_qr_code: "Smart QR code",
  regenerate_image: "Regenerate image",
  updating_qr: "Updating QR...",
  copied: "Copied",
  copy: "Copy",
  print_qr: "Print QR",
  print_visit_card: "Print business card",
  send_link: "Send link",
  customer_list: "Customer list",
  order_list: "Order list",
  reserved_appointments: "Reserved appointments",
  feedback: "Feedback",
  request_form: "Request form",
  transfer_ownership: "Transfer ownership",
  select_nfc_card: "Select NFC card",
  created_at: "Created",
  last_edit: "Last edit",
  qr_card: "QR card",
  viewed: "Viewed",
  see_more: "See more",
  download: "Download",
  activate: "Activate",
  design: "Design",
  qr_settings: "QR settings",
  deactivate: "Deactivate",
  qr_color_size: "QR colour and size",
  dots_design_color: "Dot design and colour",
  eye_design_color: "Eye design and colour",
  border_design_color: "Border design and colour",
  logo_settings: "Logo settings",
  download_qr_comment: "Download QR",
  connection_established: "Connection established.",
  show_qr: "Show QR",
  preview: "Preview",
  user_info: "User information",
  sms_club_membership: "SMS club membership",
  smart_settings: "Smart settings",
  add_audio_file: "Add audio file",
  back: "Back",
  after_click_location: "After clicking location, select your map app.",
  phone_number: "Phone number",
  auto_display: "Auto display",
  customer_club: "Customer club",
  auto_download: "Auto download",
  save: "Save",
  about_us: "About us",
  view_more: "View more",
  view_less: "View less",
  audio_file: "Audio file",
  add_video: "Add video",
  add_image: "Add image",
  select_color: "Select colour",
  header_color: "Header text",
  add_social_networks: "Add social networks",
  format: "Format",
  output_size: "Output size",
  file_type: "File type",
  default: "Default",
  qr_download_error: "There was a problem downloading the QR. Try again",
  header_color_text_settings: "Header colour and text settings",
  upload_catalog_images: "Upload catalogue/brochure images",
  delete: "Delete",
  personal_domain: "Personal domain",
  no_domain_found: "No domain found!",
  enter_domain_address: "Please enter your domain address",
  dns_setup_note: "Remember to set up server DNS first!",
  attention: "Attention: ",
  dns_setup_instruction: "To register a personal domain, first set up DNS",
  and: "and",
  setup_on_domain: "on your domain.",
  dns_change_time: "(DNS change may take up to 24 hours)",
  add_domain: "Add domain",
  add_personal_domain: "Add personal domain",
  min_characters: "Minimum input characters",
  domain_format:
    "The website domain must be in the format https://terminalads.com or terminalads.com.",
  invalid_domain: "The entered domain is invalid!",
  domain_added_successfully: "Your domain has been added successfully",
  invalid_dns_settings: "DNS settings are invalid!",
  deleted_successfully: "Deleted successfully",
  location: "Location",
  save_contact: "Save contact",
  search: "Search",
  data_fetch_error: "Error fetching data!",
  error: "Error",
  view_qr: "View QR",
  qr_design: "QR design",
  register: "Register",
  terminal_ads: "Terminal Ads",
  manage_40_advertising_methods: "Manage 40 advertising methods at once!",
  ms_khansari: "Ms Khansari",
  support: "Support",
  comprehensive_advertising_system:
    "The only comprehensive system for checking and managing online ads",
  terminal_ads_description:
    "Terminal Ads system prides itself on continuous and effective communication with customers and users to understand their needs and provide the best solutions. Our greatest capital is our loyal customers and users, followed by our expert team that supports the company with new ideas and modern technologies.",
  please_enter_qr_address_correctly: "Please enter the QR address correctly!",
  server_error: "Server error!",
  please_enter_your_address: "Please enter your address",
  please_enter_instagram_address: "Please enter your Instagram address",
  please_enter_whatsapp_address: "Please enter your WhatsApp address",
  enter_information: "Enter information",
  dynamic_qr: "Dynamic QR",
  coming_soon: "Coming soon",
  qr_name: "QR name",
  for_default_address_leave_empty: "!Leave empty for default address",
  default_address: "Default address",
  sms: "SMS",
  enter_number_without_zero: "Enter number without 0.",
  number: "Number",
  country_code: "Country code:",
  sms_text: "SMS text",
  complete_sms_fields_correctly: "Please complete the SMS fields correctly!",
  qr_code_created_successfully: "Your QR code has been created successfully.",
  chat: "Chat",
  call: "Call",
  please_enter_username: "Please enter your username.",
  username: "Username",
  sample_menu: "Sample Menu",
  online_menu_name: "Your Online Menu Name",
  online_menu_name_short: "Online Menu Name",
  enter_menu_information: "Enter menu information",
  select_sample_menu: "Select a sample menu",
  select_ready_menu: "Select a ready menu",
  online_sales: "Online Sales",
  sales_settings: "Sales Settings",
  photo_gallery: "Photo Gallery",
  fast_food1: "Fast Food 1",
  fast_food2: "Fast Food 2",
  products: "Products",
  pizzas: "Pizzas",
  pizza_rust_beef: "Pizza Roast Beef",
  italian_pizza_with_beef: "🤩 Italian Pizza with Beef",
  italian_pizza_dough_30cm: "Italian Pizza Dough 30 cm",
  "100g_shredded_beef": "100 g Shredded Beef",
  mushroom_bell_pepper: "Mushroom, Bell Pepper",
  black_olives: "Black Olives",
  pizza_chicken_mushroom: "Pizza Chicken & Mushroom",
  classic_40cm: "🍕 Classic 40 cm",
  fresh_tomato_sauce:
    "Fresh Tomato Sauce, Cheese, Chicken Fillet, Mushroom, Mountain Thyme",
  pizza_meat_mushroom: "Pizza Meat & Mushroom",
  meat_pizza_with_mushroom: "🥰 Pizza with Minced Meat and Mushroom",
  pizza_vegetables: "Vegetable Pizza",
  american_vegetable_pizza: "🍕 American Vegetable Pizza",
  american_pizza_dough:
    "American Pizza Dough, Sweetcorn, Mushroom, Olives, Tomatoes, Onion, Pepper, Cheese",
  special_pizza: "Special Pizza",
  american_special_pizza: "American Special Pizza",
  pizza_bolognese: "Pizza Bolognese",
  one_person_23cm: "(1 Person) Pizza Dough 23 cm 🤌",
  pepperoni_pizza: "Pepperoni Pizza",
  one_person_23cm_dough: "(1 Person) Pizza Dough 23 cm",
  bacon_pizza: "Bacon Pizza",
  one_person_23cm_explosion: "(1 Person) Pizza Dough 23 cm 💥",
  mixed_pizza: "Mixed Pizza",
  one_person_23cm_mixed: "(1 Person) Pizza Dough 23 cm 🤭",
  american_steak_pizza: "American Steak Pizza",
  one_person_23cm_steak: "(1 Person) 23 cm 💥",
  burgers: "Burgers",
  cheese_burger: "Cheeseburger",
  with_french_fries: "🤩 with French Fries",
  "2_beef_burgers_150g": "2 Beef Burgers 150 g each",
  special_sauce_gouda_cheese: "Special Sauce, Gouda Cheese",
  pickles_lettuce_tomato: "Pickles, Lettuce, Tomato",
  special_sauce: "Special Sauce",
  burger: "Burger",
  pure_meat_with_special_sauce: "😍 Pure Meat with Special Sauce",
  chicken_burger: "Chicken Burger",
  grilled_chicken_burger_with_cheese: "Grilled Chicken Burger with Cheese",
  spicy_burger: "Spicy Burger",
  beef_with_spicy_sauce: "Beef with Spicy Sauce",
  double_burger: "Double Burger",
  "150g_beef": "Beef 150 g",
  royal_burger: "Royal Burger",
  "150g_beef_emoji": "150 g Beef 🍔",
  mushroom_burger: "Mushroom Burger",
  "150g_beef_mushroom": "Beef 150 g",
  mushroom_burger_grilled: "Mushroom Burger",
  "100_percent_grilled_beef": "100 % Grilled Beef 🤩",
  fried_burger: "Fried Burger",
  "100_percent_grilled_fried": "100 % Grilled and Fried Beef 👌",
  fried: "Fried",
  fried_chicken: "Fried Chicken",
  "3_piece_fried_chicken": "😍 3 Pieces Fried Chicken",
  "3_fried_chicken_pieces": "3 Pieces Fried Chicken",
  "120_150g_french_fries": "120-150 g French Fries",
  enter_product_information: "Enter product information",
  product_name: "Your Product Name",
  product_name_short: "Product Name",
  complete_features_from_image: "Complete features from product image",
  skip_step: "Skip step",
  product_and_information: "Product and Information",
  product_introduction: "Product Introduction",
  shiva_waves: "Shiva Waves",
  think_best: "Think best...",
  iran_zanjan_abhar:
    "Iran, Zanjan, Abhar, Sharif Industrial Zone, next to 63/20 kV substation",
  video_gallery_description: "Watch our videos.",
  gallery: "Gallery",
  welcome: "Welcome",
  invalid_address: "The address you entered is invalid!",
  product_created_successfully: "Your product has been created successfully.",
  qr_visit_card_edited_successfully:
    "Your visit card has been edited successfully.",
  change_header_color: "Change header colour",
  change_body_color: "Change body colour",
  change_button_colors: "Change button colours",
  change_text_colors: "Change text colours",
  gradient_colors: "Gradient colours",
  color_direction: "Colour direction",
  first_color: "First colour",
  second_color: "Second colour",
  color: "Colour",
  text_color: "Text colour",
  from_top: "From top",
  from_bottom: "From bottom",
  from_left_to_right: "From left to right",
  from_right_to_left: "From right to left",
  from_top_to_left: "From top left",
  from_top_to_right: "From top right",
  from_bottom_to_left: "From bottom left",
  from_bottom_to_right: "From bottom right",
  sharing: "Sharing",
  business_shop: "Business / Shop",
  corporate_organizational: "Company / Organisational",
  customer_contact: "Customer Contact",
  information: "Information",
  miscellaneous: "Miscellaneous",
  link: "Link",
  margin: "Margin",
  width: "Width",
  height: "Height",
  background_color: "Background colour",
  gradient_color: "Gradient colour",
  linear: "Linear",
  radial: "Radial",
  color_rotation: "Colour rotation",
  background_color_label: "Background colour",
  dots_color: "Dots colour",
  dots_color_label: "Dots colour",
  eye_colors: "Eye colours",
  separate_colors_for_each_eye: "Separate colours for each eye",
  current_mode: "Current mode:",
  separate_colors: "Separate colours",
  same_color: "Same colour",
  all_eyes_color: "Colour of all eyes",
  top_right_eye: "Top right eye",
  top_left_eye: "Top left eye",
  bottom_left_eye: "Bottom left eye",
  upload_logo: "Upload logo",
  hide_background_dots: "Hide dots behind logo",
  logo_size: "Logo size",
  logo_margin: "Logo margin",
  qr_accuracy: "QR accuracy",
  mode: "Mode",
  error_correction_level: "Error correction level",
  numeric: "Numeric",
  alphanumeric: "Alphanumeric",
  byte: "Byte",
  apply_changes: "Apply changes",
  please_click_apply_changes:
    'Click "Apply changes" after selecting modifications.',
  created_qr_codes: "Created QR codes",
  square_ratio: "1:1 (square)",
  image_upload_error: "Image upload error!",
  visit_card_name_label: "Visit card name",
  sms_membership_message: "SMS membership message for customer club",
  admin_menu: "Admin Menu",
  user_menu: "User Menu",
  guide_tooltip: "Guide",
  close: "Close",
  browser_video_support_error:
    "Your browser does not support any video format.",
  video_loading_error: "Error loading video (access may be restricted).",
  click_more_for_videos: "Click More to see more videos.",
  more_info: "More information",
  more: "More",
  add_user_guide: "Add user guide",
  edit_user_guide: "Edit user guide",
  display_info: "Display information",
  element: "Element",
  disable_attach: "Disable attachment to fit page",
  view: "View",
  guide: "Guide",
  details: "Details",
  guide_images: "Guide images",
  guide_videos: "Guide videos",
  faq: "Frequently Asked Questions",
  data_preload_error: "Error preloading data:",
  guide_not_found: "No guide found. Create a guide first.",
  delete_guide_question: "Delete guide?",
  delete_guide_error: "Error deleting guide!",
  unknown_file_type: "Unknown file type:",
  content_type_error: "Error receiving content type:",
  video: "Video",
  image: "Image",
  guide_data_error: "Error receiving guide data:",
  add_iranian_stores: "Add Iranian stores",
  add_foreign_stores: "Add foreign stores",
  bazaar: "Bazaar",
  myket: "Myket",
  app_store: "App Store",
  google_play: "Google Play",
  samsung_store: "Samsung Store",
  xiaomi_store: "Xiaomi Store",
  vivo_store: "Vivo Store",
  amazon_store: "Amazon Store",
  bazaar_app: "Bazaar App",
  bazaar_link_placeholder: "Enter Bazaar app link",
  bazaar_link_hint:
    "Enter a valid Bazaar link (e.g. https://cafebazaar.ir/app/com.abankefarda)",
  myket_app: "Myket App",
  myket_link_placeholder: "Enter Myket app link",
  myket_link_hint:
    "Enter a valid Myket link (e.g. myket://details?id=com.example)",
  app_store_app: "App Store App",
  app_store_link_placeholder: "Enter App Store app link",
  app_store_link_hint:
    "Enter a valid App Store link (e.g. https://apps.apple.com/gb/app/appname/id123456789)",
  google_play_app: "Google Play App",
  google_play_link_placeholder: "Enter Google Play app link",
  google_play_link_hint:
    "Enter a valid Google Play link (e.g. https://play.google.com/store/apps/details?id=com.example)",
  samsung_store_app: "Samsung Store App",
  samsung_store_link_placeholder: "Enter Samsung Store app link",
  samsung_store_link_hint:
    "Enter a valid Samsung Store link (e.g. https://galaxy.store/appname)",
  xiaomi_store_app: "Xiaomi Store App",
  xiaomi_store_link_placeholder: "Enter Xiaomi Store app link",
  xiaomi_store_link_hint: "Enter a valid Xiaomi Store link",
  vivo_app_store: "Vivo App Store",
  vivo_app_store_app: "Vivo App Store App",
  vivo_app_store_link_placeholder: "Enter Vivo App Store app link",
  vivo_app_store_link_hint: "Enter a valid Vivo App Store link",
  amazon_store_app: "Amazon Store App",
  amazon_store_link_placeholder: "Enter Amazon Store app link",
  amazon_store_link_hint: "Enter a valid Amazon Store link",
  iranian_store: "Iranian Store",
  foreign_store: "Foreign Store",
  personal_store: "Personal Store",
  image_logo: "Image/Logo",
  image_gallery: "Image Gallery",
  header_image: "Header Image",
  template_background_image: "Template Background Image",
  background_image: "Background Image",
  background_image_alt: "Background Image",
  logo_upload: "Upload Logo",
  welcome_image: "Welcome Image",
  welcome_image_logo_upload: "Upload Welcome Image/Logo",
  loading_animation: "Loading Animation",
  preview_welcome_page: "Preview Welcome Page",
  max_background_size: "Maximum size per background image: 2 MB.",
  max_logo_size: "Maximum size per logo: 2 MB.",
  scale_from_center: "Scale from centre",
  slide_from_left: "Slide from left",
  slide_from_top: "Slide from top",
  fade: "Fade",
  select_music_card: "Select music card",
  show_audio: "Show audio",
  hide_audio: "Hide audio",
  add_voice: "Add voice",
  max_files_limit: "You cannot select more than {count} files!",
  files_not_allowed: "Files not allowed!",
  voice_gallery: "Voice Gallery",
  edit_voice: "Edit voice",
  list: "List",
  file_name: "File name",
  title: "Title",
  description: "Description",
  selectdate: "Select date",
  background: "Background",
  text: "Text",
  delete_audio_confirm:
    "Are you sure you want to delete the audio file from your gallery?",
  add_voice_gallery: "Add voice gallery",
  gallery_number: "Gallery",
  delete_confirm: "Are you sure you want to delete?",
  confirm: "?",
  voice_gallery_title_hint: "Enter your voice gallery title.",
  voice_gallery_title: "Title",
  voice_gallery_subtitle_hint: "Enter your voice gallery subtitle.",
  voice_gallery_subtitle: "Voice Gallery Subtitle",
  voice_gallery_subtitle_alt: "Subtitle",
  website_address_hint: "Enter your website address.",
  website_address: "Website Address",
  about_voice_gallery: "About the Gallery",
  about_voice_gallery_alt: "About the Gallery",
  button_name_hint: "Enter button name.",
  button_name: "Button Name",
  domain_format_hint:
    "The domain must be https://terminalads.com or terminalads.com.",
  about_us_alt: "About Us",
  add_default_form: "Add default form",
  delete_all: "Delete all",
  validation_active: "Validation: Active",
  validation_inactive: "Validation: Inactive",
  validation: "Validation",
  clear_form: "Clear form",
  status: "Status",
  active: "Active",
  inactive: "Inactive",
  optional: "Optional",
  required: "Required",
  question_title: "Title",
  question_title_hint: "Enter question title",
  options_hint: "Write options and press Enter to add",
  options: "Options",
  add_suggested_form: "Add suggested form",
  save_changes: "Save changes",
  add_request_field: "Add request field",
  select_form_type: "Select form type",
  select_form_type_placeholder: "Select form type",
  dropdown: "Dropdown",
  text_field: "Text field",
  number_field: "Number field",
  textarea_field: "Textarea field",
  date_field: "Date field",
  field_name_required: "Field name cannot be empty",
  field_name: "Field name",
  add_field_name: "Add field name",
  field_label: "Field label",
  add_field_label: "Add field label",
  advanced_settings: "Advanced settings",
  select_input_pattern: "Select input pattern",
  select_input_pattern_placeholder: "Select input pattern",
  max_characters: "Maximum characters",
  min_input_error: "Minimum input must be 0",
  name_field: "Name",
  field_type: "Field type",
  persian_limit: "Persian language restriction",
  family_name: "Family name",
  mobile_number: "Mobile number",
  number_limit: "Number restriction",
  national_code: "National code",
  meli_code: "National code",
  email: "Email",
  email_limit: "Email restriction",
  dropdown_field: "Dropdown field",
  english_limit: "English language restriction",
  mix_per_eng_limit: "Persian-English mix restriction",
  site_limit: "Site restriction",
  form_added_successfully: "New form added successfully",
  form_updated_successfully: "Form updated successfully",
  delete_item_confirm: "Are you sure you want to delete the item?",
  default_form_added_successfully: "Default form added successfully",
  resources_upload_error: "Error uploading resources",
  update_value_if_duplicate: "Update value if duplicated",
  first_tab: "First tab",
  display_count: "Display count",
  buy_renew_qr_instruction:
    "To buy/renew QR, click the expiry duration button.",
  days_until_expiry: "Days until expiry",
  expired: "Expired",
  no_qr_to_display: "No QR to display!",
  second_tab: "Second tab",
  total_qr_codes: "Total QR codes",
  select_all: "Select all",
  selected_qr_codes_count: "Number of selected QR codes",
  qr_codes_count: "QR codes count",
  group_renewal_instruction: "For group renewal, select desired QR codes.",
  no_qr_found_with_filters: "No QR found with these filters!",
  qr_codes_count_label: "QR codes count:",
  renew_qr: "Renew QR",
  days: "Days",
  buy_now: "Buy now!",
  buy_now_label: "Buy",
  add_discount_code: "Add discount code",
  use_discount_code: "Use discount code",
  discount_code: "Discount code",
  submit: "Submit",
  my_qr_list: "My QR List",
  group_renewal: "Group Renewal",
  row: "Row",
  type: "Type",
  clicks: "Clicks",
  created_at_diff: "Creation time",
  updated_at_diff: "Update time",
  table_view: "Table view",
  normal_view: "Normal view",
  no_qr_or_id_selected: "No QR or ID selected!",
  qr_updated_successfully: "QR updated successfully.",
  qr_update_error: "Error updating QR!",
  no_qr_selected: "No QR selected!",
  no_qr_code_selected: "No QR code selected!",
  success: "Success",
  qrs_upgraded_successfully: "Your QRs upgraded successfully.",
  qr_renewal_error: "Problem with QR renewal request!",
  changed_successfully: "Changed successfully.",
  error_occurred: "An error occurred!",
  no_tariff_exists: "No tariff exists!",
  qr_upgraded_successfully: "Your QR upgraded successfully.",
  check_account_balance: "Check your account balance and try again later.",
  group_renewal_price_error: "Error retrieving group renewal price!",
  qr_count_error: "Error retrieving QR count!",
  no_qr_for_renewal: "No QR for renewal!",
  table_pagination: "Table pagination",
  virtual_scroll_display: "Virtual scroll display",
  popups_shared_components: "Pop-ups and shared components",
  edit_qr_address: "Edit QR address",
  please_enter_correct_address: "Please enter correct address",
  successfully_edited: "Edited successfully.",
  error_editing_qr_address: "Error editing QR address!",
  go_to_page: "Go to page",
  page_from_to: "Page {current} of {last}",
  display: "Display",
  to: "to",
  from: "from",
  show: "Show",
  page_status: "Page {current} of {total}",
  until: "until",
  successfully_completed: "Completed successfully",
  problem_occurred: "A problem occurred",
  download_failed: "Download failed",
  audio_file_default: "Audio file",
  memory_release: "Memory release",
  seek_music_comment: "For example this music or anything being searched",
  all: "All",
  create_podcast: "Create podcast",
  add_link: "Add link",
  upload_file: "Upload file",
  file_list: "File list",
  count: "Count",
  select_category: "Select category",
  after_typing_enter: "After typing, press Enter.",
  no_image_available: "No image available",
  no_image_found: "No image found!",
  for_adding_file_use_upload_center:
    "To add a file, use the upload field or upload centre",
  ai_story_creation_description: "Enter your story, AI will create it for you",
  create_new_podcast: "Create new podcast",
  show_audio_file: "Show audio file",
  cancel: "Cancel",
  no_audio_in_category: "No audio files in this category",
  health_apple: "Health Apple",
  standard: "Standard",
  arshia_badge: "Arshia Badge",
  home_appliances_association: "Home Appliances Association",
  energy_label: "Energy Label",
  select_gold_purity_first: "To get the price, first select gold purity",
  gold_price_service: "Gold price service",
  rahvard: "Rahvard",
  to_change_gold_service_go_to_assets:
    "To change gold price service, go to assets section",
  gold: "Gold",
  purity: "Purity",
  rial: "Rial",
  final_product_price: "Final product price",
  show_images_right_side: "Show images on right side",
  show_as_slider: "Show as slider.",
  show_as_grid: "Show as grid.",
  show_as_second_mode: "Show as second mode.",
  gallery_name: "Gallery name",
  change_gallery_name: "Change gallery name",
  add_photo: "Add photo",
  select_photo: "Select photo",
  show_image: "Show image",
  selected_photo: "Selected photo",
  to_use_ready_images_search_category_or_product:
    "To use ready images, search category or product above.",
  max_file_size_2mb: "Maximum file size: 2 MB.",
  drag_and_drop_to_upload_or: "Drag and drop to upload or",
  here: "here",
  click: "click",
  to_use_external_image_link_fill_fields:
    "To use external image link, fill fields below",
  image_url_hint: "Desired image URL (link).",
  image_url: "Image link",
  add_new_gallery: "Add new gallery",
  create_image: "Create image",
  ready_images: "Ready images",
  edit_image: "Edit image",
  enter_valid_link: "Enter valid link.",
  max_background_image_size_2mb: "Maximum size per background image: 2 MB.",
  uploaded_successfully: "Uploaded successfully.",
  banner: "Banner",
  question: "Question",
  selected_question: "Selected question",
  answer: "Answer",
  add_question: "Add question",
  selected_blog: "Selected blog",
  icon: "Icon",
  select_icon: "Select icon",
  add_blog: "Add blog",
  post: "Post",
  selected_services: "Selected services",
  add_new_post: "Add new post",
  add_new_services: "Add new services",
  add_new_service: "Add new service",
  domain_must_be_https_or_http:
    "The domain must be https://terminalads.com or terminalads.com.",
  id: "ID",
  images: "Images",
  tags: "Tags",
  print_type: "Print type",
  user: "User",
  user_shipping_info: "User shipping information",
  qr_short_link: "QR short link",
  delivery_method: "Delivery method",
  delivery_at_company: "Delivery at company",
  delivery_by_post: "Delivery by post",
  post_cost_and_tax_warning:
    "Upon registration, postage and 10% tax will be deducted from your wallet.",
  shipping_info: "Shipping information",
  continue_shopping: "Continue shopping",
  complete_shopping: "Complete purchase",
  select_free_nfc_card: "Select free NFC card",
  order_custom_nfc_card: "Order custom NFC card",
  buy_qr_equipment: "Buy QR equipment",
  vertical: "Vertical",
  horizontal: "Horizontal",
  card_type: "Card type",
  tag: "Tag",
  select: "Select",
  order_card: "Order card",
  available: "Available",
  unavailable: "Unavailable",
  for_initial_loading: "For initial loading",
  already_have_free_nfc_message:
    "You have already received a free NFC for this QR. To change, purchase a custom card.",
  nfc_in_delivery_process_message:
    "You have already registered a free NFC which is on its way. To change, purchase a custom one.",
  free_nfc_card_warning_message:
    "Dear user: Free NFC cards are pre-printed, your QR changes. If used, purchase a custom one.",
  select_card: "Select card",
  free_card_selection_conditions: "Free card selection conditions",
  confirm_and_select: "Confirm and select",
  registered_successfully: "Registered successfully.",
  error_registering_nfc_order: "Error registering NFC card order!",
  nfc_physical_card_orders: "Physical NFC card orders",
  buy_equipment: "Buy equipment",
  select_quantity: "Select quantity",
  ready_samples: "Ready samples",
  upload_custom_design: "Upload custom design",
  select_ready_card_image: "Select ready card image",
  select_card_front_image: "Select card front image",
  select_card_back_image: "Select card back image",
  nfc_card_image: "NFC card image",
  add_quantity: "Add quantity",
  total_price: "Total price",
  price_with_discount: "Price with discount",
  shipping_cost: "Shipping cost",
  your_profit_from_purchase: "Your profit from purchase",
  discount: "Discount",
  ten_percent_tax_will_be_added: "10% tax will be added to the final amount.",
  payable_amount: "Payable amount",
  continue: "Continue",
  Confirm_code: "Confirm code",
  form_success_message: "Your form has been sent successfully",
  refill_form_message: "Please refill the form",
  Enter_the_sent_code: "Enter the code sent to you",
  SUBMIT_FORM: "Submit form",
  enter_phone_number: "Enter your mobile number",
  order_registered_successfully: "Your order has been registered successfully.",
  smart_creation: "Smart creation",
  automatic_creation: "Automatic creation",
  business_name: "Business name",
  example_household_goods: "Example: Household goods",
  organization_name: "Organisation name",
  example_tech_company: "Example: Advanced technology company",
  minimum_two_characters_required: "At least two characters required!",
  maximum_100_characters_allowed: "Maximum 100 characters allowed",
  latin_name_qr_address: "Latin name (QR address)",
  example_advanced_tech: "Example: advanced-tech",
  only_english_numbers_dash_allowed:
    "Only English letters, numbers and dash allowed",
  maximum_50_characters_allowed: "Maximum 50 characters allowed",
  latin_name_goes_after_domain: "Latin name goes after the domain",
  select_logo_and_store_product_image: "Select logo and shop/product image",
  select_logo: "Select logo",
  file_size_must_be_less_than_2mb: "File size must be less than 2 MB",
  for_buying_renewing_qr_click_expiry_button:
    "To buy/renew QR, click the expiry duration button.",
  for_group_renewal_select_desired_qr_codes:
    "For group renewal, select desired QR codes.",
  no_qr_found_with_these_filters: "No QR found with these filters!",
  i_buy: "I buy",
  visits: "Visits",
  creation_time: "Creation time",
  edit_time: "Edit time",
  enter_business_card_name_correctly: "Enter business card name correctly!",
  are_you_sure_delete_qr: "Are you sure you want to delete the QR?",
  qr_deleted_successfully: "QR deleted successfully.",
  are_you_sure_deactivate_qr: "Are you sure you want to deactivate the QR?",
  are_you_sure_activate_qr: "Are you sure you want to activate the QR?",
  deactivated: "Deactivated",
  qr_successfully: "QR successfully",
  successfully: "Successfully",
  user_transferred_successfully: "User transferred successfully",
  problem_occurred_in_transfer: "Problem occurred in transfer!",
  error_in_user_transfer: "Error in user transfer!",
  qr_business_card_edited_successfully:
    "Your business card has been edited successfully.",
  group_qr_renewal: "Group QR renewal",
  select_desired_duration: "Select desired duration",
  total_count: "Total count",
  final_amount: "Final amount",
  ten_percent_vat_will_be_added: "10% VAT will be added to the amount above.",
  pay_and_upgrade: "Pay and upgrade",
  no_tariff_for_this_period: "No tariff for this period!",
  selected: "Selected",
  total_amount: "Total amount",
  final_amount_with_discount: "Final amount with discount",
  add_qr: "Add QR",
  actions: "Actions",
  filter_type: "Type filter",
  start_from: "Start from",
  search_in_id: "Search in ID",
  filter_user: "User filter",
  clear_filters: "Clear filters",
  send_sms: "Send SMS",
  selected_pattern: "Selected pattern",
  send: "Send",
  bulk_download: "Bulk download",
  one_month_renewal: "One-month renewal",
  three_month_renewal: "Three-month renewal",
  six_month_renewal: "Six-month renewal",
  one_year_renewal: "One-year renewal",
  no_item_selected: "No item selected!",
  error_loading_card_info: "Error loading card information!",
  send_registered_successfully: "Send registered successfully",
  error_getting_prices: "Error getting prices!",
  payment_error: "Payment error!",
  business_card: "Business Card",
  product_label: "Product Label",
  restaurant_menu: "Restaurant Menu",
  event_ticket: "Event Ticket",
  brochure: "Brochure",
  flyer: "Flyer",
  poster: "Poster",
  catalog: "Catalogue",
  newsletter: "Newsletter",
  organization_name_hint: "Enter your organisation name.",
  organization_name_label: "Organisation Name",
  sub_organization_hint: "Enter sub-organisation name.",
  sub_organization_label: "Sub-organisation name description",
  user_name_hint: "Enter your name.",
  user_name_label: "Name and Surname",
  work_field_hint: "Enter your job position.",
  work_field_label: "Position",
  mobile_number_hint: "Enter your number.",
  mobile_number_label: "Mobile Number",
  phone_number_hint: "Enter phone number.",
  phone_number_label: "Phone Number",
  email_hint: "Enter your email.",
  email_label: "Email",
  fax_hint: "Enter company fax.",
  fax_label: "Company Fax",
  website_hint: "Enter company website.",
  website_label: "Company Website",
  postal_code_hint: "Enter postal code.",
  postal_code_label: "Postal Code",
  copyright_hint: "Enter copyright text in footer.",
  copyright_label: "Copyright Text",
  address_hint: "Enter your address.",
  address_label: "Address",
  add_more_info: "Add more information you want:",
  edit_location: "Edit",
  add_location: "Add",
  delete_location: "Delete location",
  about_us_label: "About Us",
  search_address: "Search address:",
  northern_coordinates: "Northern coordinates",
  eastern_coordinates: "Eastern coordinates",
  select_address_on_map: "Select address on map",
  location_not_found: "Location not found.",
  text_label: "Text",
  number_label: "Number",
  website_address_label: "Website Address",
  location_label: "Location",
  mobile_viewer_title: "Mobile Viewer",
  visit_theme_two_title: "Visit Card Theme 2",
  visit_theme_flipped_title: "Flipped Visit Card Theme",
  flip_card: "Flip card",
  flip_card_description: "To see more information, flip the card",
  share_contacts: "Share contacts",
  close_share: "Close sharing",
  card_front: "Card front",
  card_back: "Card back",
  flip_to_back: "Flip to back",
  flip_to_front: "Flip to front",
  swipe_to_flip: "Swipe to flip",
  swipe_left: "Swipe left",
  swipe_right: "Swipe right",
  expand_card: "Expand card",
  contract_card: "Contract card",
  view_details: "View details",
  hide_details: "Hide details",
  social_media_share: "Social media sharing",
  contact_actions: "Contact actions",
  card_actions: "Card actions",
  floating_menu: "Floating menu",
  close_menu: "Close menu",
  open_menu: "Open menu",
  choice_gallery: "Selected gallery",
  choice_video: "Select video",
  url_video: "Video link",
  selected_video: "Selected video",
  add_video: "Add video",
  edit_video: "Edit video",
  linl_video: "Transfer link",
  upload_video: "Upload video",
  rule_link: "The domain must be https://terminalads.com or terminalads.com.",
  fax_hint: "Enter company fax.",
  fax_label: "Company Fax",
  website_hint: "Enter company website.",
  website_label: "Company Website",
  postal_code_hint: "Enter postal code.",
  postal_code_label: "Postal Code",
  add_more_info: "Add more information you want:",
  address_hint: "Enter your address.",
  address_label: "Address",
  edit_location: "Edit",
  add_location: "Add",
  delete_location: "Delete location",
  location_label: "Location",
  about_company_label: "About the Company",
  select_address_on_map: "Select address on map",
  search_address: "Search address:",
  rule_link: "The domain must be https://terminalads.com or terminalads.com.",
  link_label: "Link address",
  label_label: "Label",
  field_value_label: "Field value",
  add_new_field: "Add new field",
  tehran_address:
    "Tehran, Shariati Street, after Seyed Khandan Bridge, Khandan Alley, No. 6",
  welcome_message_hint:
    "If enabled, when the customer joins your club, a welcome message will be sent.",
  change_pattern_campaign: "Change pattern/campaign",
  selected_message: "Selected message:",
  required_inputs: "Required inputs:",
  selected_campaign_or_pattern: "Selected campaign/pattern:",
  campaign: "Campaign",
  pattern: "Pattern",
  id: "ID",
  auto_csv_download_label: "Automatic save",
  auto_csv_download_hint:
    "After opening the card, your information will be automatically downloaded to the customer's mobile.",
  show_cclub_onload_label: "Membership suggestion",
  show_cclub_onload_hint: "A window will open for joining the customer club.",
  forced_submission_hint:
    "With the membership form display, the customer must register their number.",
  forced_submission_forced: "Forced membership",
  forced_submission_optional: "Optional membership",
  has_manifest_icons_label: "Web app customisation",
  has_assistant_label: "Assistant Label",
  select_assistant: "Select Assistant",
  search_assistant: "Search assistant...",
  add_new_assistant: "Add New Assistant",
  expires_today: "Expires today",
  one_day_remaining: "1 day remaining",
  days_remaining: "days remaining",
  weeks_remaining: "weeks remaining",
  months_remaining: "months remaining",
  no_expiry_date: "No expiry date",
  assistant_ai: "AI Assistant",
  has_manifest_icons_hint:
    "The logo and image will appear when the web app is installed on mobile or computer.",
  logo_144px: "Logo 144 px",
  logo_48px: "Logo 48 px",
  photo_wide: "Wide photo",
  photo: "Photo",
  iranian_social_networks: "Iranian social networks",
  foreign_social_networks: "Foreign social networks",
  advertising_sites: "Advertising sites",
  other_links: "Other links",
  custom_text: "Custom text",
  custom_text_placeholder: "Enter your custom text.",
  aparat: "Aparat",
  aparat_hint: "Enter your channel name on Aparat",
  eitaa: "Eitaa",
  eitaa_hint: "Enter your username",
  soroush: "Soroush",
  soroush_hint: "Enter your username",
  bale: "Bale",
  bale_hint: "Enter your username",
  rubika: "Rubika",
  rubika_hint: "Enter channel/group link",
  gap: "Gap",
  gap_hint: "Enter your username",
  linkedin: "LinkedIn Personal Profile",
  linkedin_hint: "Enter your username",
  linkedin_company: "LinkedIn Company Page",
  linkedin_company_hint: "Enter your company page name",
  pinterest: "Pinterest",
  pinterest_hint: "Enter your username",
  dribbble: "Dribbble",
  dribbble_hint: "Enter your username",
  facebook: "Facebook",
  facebook_hint: "Enter your username",
  github: "GitHub",
  github_hint: "Enter your username",
  threads: "Threads",
  threads_hint: "Enter your username",
  tiktok: "TikTok",
  tiktok_hint: "Enter your username",
  twitter: "Twitter",
  twitter_hint: "Enter your username",
  skype: "Skype",
  skype_hint: "Enter your username",
  youtube: "YouTube",
  youtube_hint: "Enter your username without @",
  wechat: "WeChat",
  wechat_hint: "Enter your username",
  viber: "Viber",
  viber_hint: "Enter your username",
  divar: "Divar",
  divar_hint: "Enter advert/board/shop link",
  sheypoor: "Sheypoor",
  sheypoor_hint: "Enter advert/board/shop link",
  social_network: "Social Network",
  photo_logo_tab: "Image/Logo",
  gallery_image_tab: "Image Gallery",
  template_image: "Template Image",
  background_image: "Background Image",
  upload_logo: "Upload Logo",
  welcome_image_upload: "Upload Welcome Image/Logo",
  welcome_photo: "Welcome Photo",
  loading_animation: "Loading Animation",
  preview_welcome_page: "Preview Welcome Page",
  default_template_image: "Default Template Background Image",
  default_background_image: "Default Background Image",
  default_logo: "Default Logo",
  default_welcome: "Default Welcome",
  default_gallery: "Default Gallery",
  animation_scale: "Scale from centre",
  animation_slide_x: "Slide from left",
  animation_slide_y: "Slide from top",
  animation_fade: "Fade",
  image_size_error: "Maximum size per background image: 2 MB.",
  logo_size_error: "Maximum size per logo: 2 MB.",
  categories: {
    bankcard: 'QCard',
    bale: "Bale",
    robika: "Robika",
    eitaa: "Eitaa",
    text: "Text",
    multi_card: "Multi Card",
    product_introduction_pro: "Product Intro Pro",
    "gift": "Gift",
    electronic_business_card_pro: "Electronic Business Card Pro",
    link_pro:"Link Pro",
    generated_images: "Generated Images",
    electronic_business_card: "Electronic Business Card",
    social_media: "Social Media",
    photo_gallery: "Photo Gallery",
    video_gallery: "Video Gallery",
    link: "Link",
    audio_gallery: "Audio Gallery",
    audio_gallery_pro: "Audio Gallery (Pro)",
    feedback: "Feedback",
    consultation_form: "Consultation Form",
    application: "Application",
    pdf_gallery: "PDF Gallery",
    schedule_table: "Schedule Table",
    personal_company_website: "Personal/Company Website",
    online_store: "Online Store",
    online_menu: "Online Menu",
    appointment_booking: "Appointment Booking",
    commercial_admin_website: "Commercial/Admin Website",
    online_insurance_sales: "Online Insurance Sales",
    discount_code: "Discount Code",
    product_introduction: "Product Introduction",
    product_label: "Product Label",
    gold_label: "Gold Label",
    franchise: "Franchise (Business Page)",
    marketplace: "Marketplace (Business Page)",
    recruitment_form: "Recruitment Form",
    organizational_form: "Organisational Form",
    employee_card: "Employee Card",
    book_magazine: "Book/Magazine",
    catalog_brochure: "Catalogue/Brochure",
    catalog: "Catalogue",
    faq: "FAQ",
    feedback_survey: "Feedback/Survey",
    consultation_request: "Consultation Request",
    customer_club: "Customer Club",
    invitation_card: "Invitation Card",
    countdown: "Countdown",
    tombstone: "Tombstone",
  },
  support_day60: "60-day money-back guarantee",
  "enter_visit_card_pro_info": "Enter the Pro Business Card name",

  ROUTE: {
    TITLES: {
    QR_NAME_EDIT_TEXT: "Edit QR text",
    SERVER_DOWN: "System Updating",
    CREATE_MEMORIES_MODEL: "Create Memories Frame Model",
    CREATE_CARD_VISIT_PRO_MODEL: "Create Business Card Pro Model",
    CREATE_PRODUCT_PRO_MODEL: "Create Product Intro Pro Model",
    CREATE_PRODUCT_LABEL_MODEL: "Create Product Label Model",
    CREATE_PHOTO_GALLERY_MODEL: "Create Photo Gallery Model",
    CREATE_PDF_GALLERY_MODEL: "Create PDF Gallery Model",
    CREATE_SOCIAL_MEDIA_MODEL: "Create Social Media Model",
    EDIT_CARD_VISIT_PRO_MODEL: "Edit Business Card Pro Model",
    EDIT_PRODUCT_PRO_MODEL: "Edit Product Intro Pro Model",
    EDIT_PRODUCT_LABEL_MODEL: "Edit Product Label Model",
    EDIT_PHOTO_GALLERY_MODEL: "Edit Photo Gallery Model",
    EDIT_PDF_GALLERY_MODEL: "Edit PDF Gallery Model",
    EDIT_SOCIAL_MEDIA_MODEL: "Edit Social Media Model",
    BOOK: "Book",
    NFC_LIST: "NFC List",
    API_KEY_MANAGER: "Create API Key",
    PRE_PURCHASE: "Pre-Purchase",
    PRE_PURCHASE_MODEL: "Ready Template",
       "QR_NAME_EDIT_GIFT": "Edit Gift QR Code",
  "QR_GIFT": "Gift QR Code",
      "QR_NAME_EDIT_PRO": "Edit Pro Link QR Code",
        "QR_LINK_PRO": "QR Link Pro",
            DIGI: "Digikala Pricing Monitoring",
      QR_PDF: "PDF Gallery",
      QR_NAME_EDIT_PDF: "Edit PDF Gallery",
      QR_MULTICART: "QR Multi-Cart",
      QR_MULTICART_EDIT: "Edit QR Multi-Cart",
      QR_PRODUCTPRO: "Product Pro Introduction",
      QR_NAME_PRODUCTPRO: "Edit Product Pro Introduction",
      QR_CATALOG: "Catalogue / Brochure",
      QR_NAME_EDIT_CATALOG: "Edit Catalogue",
      QR_LUCK_WHEEL_Edit: "Edit Luck Wheel",
      QR_LUCK_WHEEL: "Create QR Luck Wheel",
      DASHBOARD: "Dashboard",
      ADMIN_QR_DOMAINS: "Domain Monitoring",
      ADMIN_TOGETHER_TOKEN: "Token Monitoring",
      ADMIN_QR_SMS: "Send SMS",
      MENU_PROFILE_INFO: "User Information",
      MENU_PROFILE_SETTING: "Profile Settings",
      MENU_PROFILE_ORDERS: "Orders",
      MENU_PROFILE_ADDRESSES: "Addresses",
      QR_MONITORING: "QR Monitoring",
      QR_LIST: "My QR List",
      QR_NAME_LIST: "Participation Management",
      QR_GENERATE_MULTIPLE: "Bulk QR Code Generation",
      QR_CARD_VISIT: "Create Business Card",
      HELP_INFO: "Test Button",
      QR_MENU: "Shop Menu",
      QR_APPOINTMENT: "Appointment Booking",
      QR_INSURANCE: "Create Online Insurance",
      QR_BPAGE: "Create Business Page",
      QR_CPAGE: "Create Commercial/Administrative Complex Site",
      QR_BSHOP: "Online Shop",
      QR_NAME_EDIT_BSHOP: "Edit Online Shop",
      QR_LINK_EDIT: "Edit Link",
      QR_NAME_DESIGN: "Edit Design",
      QR_NAME_SETTING: "Edit Settings",
      QR_NAME_EDIT: "Edit Business Card",
      QR_NAME_EDIT_BPAGE: "Edit Business Page",
      QR_EDIT_CPAGE: "Edit Commercial/Administrative Complex Site",
      QR_NAME_INSURANCE: "Edit Online Insurance",
      QR_NAME_EDIT_MENU: "Edit Menu",
      QR_NAME_EDIT_APPLICATION: "Provide Application",
      QR_NAME_EDIT_APPOINTMENT: "Edit Appointment Booking",
      QR_NAME_EDIT_PHOTO: "Edit Photo Gallery",
      QR_NAME_EDIT_VIDEO: "Edit Video Gallery",
      QR_NAME_EDIT_VOICE: "Edit Audio Gallery",
      QR_NAME_EDIT_FEEDBACK: "Edit Feedback Gallery",
      QR_NAME_CONSULTATION_QR_EDIT: "Edit Request Form",
      QR_NAME_EDIT_VOICE_PRO: "Edit Audio Gallery (Pro)",
      QR_NAME_EDIT_SOCIAL: "Edit Social Networks",
      QR_NAME_STATISTICS: "QR Code Statistics",
      QR_CATE: "Select Category",
      QR_SHARE: "Share",
      QR_BUSINESS_SHOP: "Business/Shop",
      QR_CO_ORGAN: "Company/Organisation",
      QR_CONTACT: "Customer Contact",
      QR_NOTICES: "Notifications",
      QR_OTHERS: "Miscellaneous",
      QR_STATICS: "Static QR",
      QR_DYNAMICS: "Dynamic QR",
      QR_D_BUSINESS: "Dynamic Business QR",
      QR_D_ORGANS: "Dynamic Organisational QR",
      QR_D_GOVERNMENT: "Dynamic Government QR",
      QR_VIDEO: "Video Gallery",
      QR_APPLICATION: "Provide Application",
      QR_VOICE: "Audio Gallery",
      QR_VOICE_PRO: "Audio Gallery (Pro)",
      QR_CONSULTATION_QR: "Request Form",
      QR_FEEDBACK: "Feedback Gallery",
      QR_PHOTO: "Photo Gallery",
      QR_LOCATION: "Create Location QR",
      QR_SOCIAL_MEDIA: "Create Social Media QR",
      QR_LINK: "Create Link",
      QR_TEXT: "Create Text",
      QR_MAIL: "Create Email",
      QR_CALL: "Call",
      QR_SMS: "SMS",
      QR_WHATSAPP: "WhatsApp",
      QR_SITE: "Website",
      QR_INSTAGRAM: "Instagram",
      QR_SKYPE: "Skype",
      QR_WIFI: "Wi-Fi",
      QR_BUSINESS: "Business Page",
      QR_DISCOUNT: "Discount Page",
      QR_PRODUCT_SHOP: "Product Introduction",
      QR_PRODUCT_LABEL: "Product Label",
      QR_GOLD_LABEL: "Gold Label",
      QR_PRODUCT_TEMPLATE: "Products",
      ADMIN_CATEGORY: "Categories",
      QR_NFC_ORDERS: "NFC Cards Awaiting Confirmation",
      QR_NAME_PRODUCT: "Edit Product Introduction",
      QR_NAME_LABELPRODUCT: "Edit Product Label",
      QR_NAME_GOLDPRODUCT: "Edit Gold Label",
      QR_COINS: "Cryptocurrencies",
      QR_SHOP: "Shop Management",
      QR_TWITTER: "Twitter",
      UPLOAD_CENTER: "Upload Centre",
      PRICING: "QR Tariffs",
      QR_CREATE_MODELS: "Create Business Card Model",
      QR_CREATE_BUSINESS_MODELS: "Create Business Page Model",
      QR_CREATE_PRODUCT_MODEL: "Create Product Card Model",
      QR_CREATE_MENU_MODELS: "Create Shop Menu Model",
      QR_CREATE_SHOP_MODEL: "Create Online Shop Model",
      MODELS_LIST: "Types of QR Models",
      MODELS_LIST_EDIT: "Edit Model",
      MODELS_LIST_MENU_EDIT: "Edit Menu Model",
      MODELS_LIST_BMODEL_EDIT: "Edit Online Shop Model",
      NFC: "NFC Cards",
      SUBMIT_FORM: "Register Blogger",
      REQUEST_LIST: "Blogger List",
      PURE_DATA: "List of Uncreated Business Cards",
      AUTO_CREATE: "Automatic QR Creation",
      QR_CREATE: "Create QR",
      HISTORY_REMINDER: "Reminder Monitoring",
      BOOK: "Reminder Monitoring"
    },
  },
  COMPONENTS: {
    QR_SHOP_MANAGER: {
      PAYMENT_METHODS: "Payment Methods",
      ORDER_NOTIFICATIONS: "Order Notifications",
      DISCOUNT_CODE: "Discount Code",
      CART: "Shopping Basket",
      TABLE_MANAGEMENT: "Table Management",
    },
    ERRORS: {
      INVALID_INPUT: "Please enter values correctly!",
      CART_SETTINGS_FAILED: "Shopping basket settings failed!",
    },
  },
  popup: {
    prepared_stores_title: "Ready-made Online Shop Samples",
  },
  buttons: {
    reset_defaults: "Reset default data",
    download_qr: "Download QR",
    cleardefaults: "Clear default information",
    select_prepared_store: "Select ready-made online shop",
  },
  stepper: {
    create_qr: "Create QR",
    products_info: "Products and Information",
    content_settings: "Content Settings",
    sales_settings: "Sales Settings",
  },
  fields: {
    online_store_name: "Online Shop Name",
    qr_address: "QR Address",
    qr_address_hint: "Enter your QR address",
    online_sale: "Online Sale",
  },
  login_settings: "Login Settings",
  shop_logo_and_images: "Shop Logo and Images",
  login_page_info: "Login Page Information",
  upload_banner: "Upload Banner",
  create_product: "Create Product",
  special_sale: "Special Sale",
  ended: "Ended",
  blog: "Blog",
  services: "Services",
  pdf_gallery: "PDF Gallery",
  create_section: "Create Section",
  achievements: "Achievements",
  team_members: "Team Members",
  working_hours: "Working Hours",
  saturday: "Saturday",
  sunday: "Sunday",
  monday: "Monday",
  tuesday: "Tuesday",
  wednesday: "Wednesday",
  thursday: "Thursday",
  friday: "Friday",
  we_will_be_different: "We shall be different...",
  striving_for_excellence: "We always strive to be our best >>> for you",
  online_store_ready_15_minutes: "Your online shop is ready in 15 minutes!",
  sales_management: "Sales Management",
  dear_customer_online_stores:
    "Dear customer, you can also shop from our other online shops:",
  divar_site: "Divar Site",
  digikala_site: "Digikala Site",
  basalam_site: "Basalam Site",
  torob_site: "Torob Site",
  emalls_site: "Emalls Site",
  copyright_qrland: "All rights reserved to QR Land.",
  tehran_address:
    "Tehran, Shariati Street, after Seyed Khandan Bridge, Khandan Cul-de-sac, No. 6",
  our_achievements: "Our collection's achievements",
  customer_satisfaction: "Customer Satisfaction",
  lowest_returns: "Lowest Returns",
  loyal_customer: "Loyal Customer",
  shipped_orders: "Shipped Orders",
  visit_our_videos: "Visit our collection's videos.",
  bringing_the_best: "We've brought the best for you...",
  feedback_important: "Your feedback is important to us",
  guide_us_with_feedback:
    "Please guide us in better services by answering the questions below.",
  satisfied_with_quality: "Were you satisfied with the quality of the goods?",
  evaluate_packaging_quality: "How do you evaluate the packaging quality?",
  satisfied_with_variety: "Were you satisfied with the variety of goods?",
  benefited_from_discounts: "Have you benefited from this shop's discounts?",
  post_1: "Post 1",
  fast_order_delivery: "Fast Order Delivery",
  post_2: "Post 2",
  post_3: "Post 3",
  product_authenticity_guarantee: "Product Authenticity Guarantee",
  comfortable_purchase: "A comfortable purchase",
  how_to_place_order: "How can I place my order?",
  add_to_cart: "Simply add your desired products to the shopping basket.",
  how_to_register: "How can I register on the site?",
  click_login_and_enter_code:
    "Simply click the 'Login' button and, after entering your mobile number, enter the SMS code.",
  delivery_time:
    "How long will it take for my order to arrive after registration?",
  fastest_delivery: "Your order will be dispatched as quickly as possible.",
  shipping_cost: "What is the shipping cost?",
  shipping_cost_order: "Order Shipping Cost",
  variable_shipping_cost: "Shipping cost varies depending on your address.",
  change_or_cancel_order:
    "Can I change or cancel my product after placing the order?",
  no_change_or_cancel: "No.\nChange or cancellation is not possible.",
  mrs_Safdarian: "Mrs Safdarian",
  invalid_address: "The entered address is invalid!",
  shop_page_created_success: "Your shop page was created successfully.",
  qr_creation_failed: "QR creation failed!",
  server_error: "Server error!",
  qr_card_updated_success: "Your business card was successfully edited.",
  qr_save_edit_failed: "Error in saving/editing QR",
  your_feedback: "Your feedback",
  digital_marketing_strategy:
    "Put your company on the right path with our digital marketing strategist",
  wait_for_default_products:
    "Please be patient until the default products are fully loaded on your site.",
  template_categories_saved: "Sample model categories saved successfully.",
  template_products_saved: "Sample model products saved successfully.",
  template_products_save_failed: "Error saving sample model products!",
  template_categories_save_failed: "Error saving sample model categories!",
  login_page_text: "Login Page Text",
  persian_error: "Text must be in Persian",
  number_error: "Input data must not be non-numeric or empty",
  english_error: "Text must not be non-English or empty",
  mixPerEng_error: "Text must not be non-English or non-Persian or empty",
  email_error: "Entered email format is invalid",
  mobile_error: "Entered number format is invalid",
  meliCode_error: "Entered national code format is invalid",
  site_error: "Entered site format is invalid",
  min_length_error: "Input value cannot be less than {{min}}",
  max_length_error: "Input value cannot be more than {{max}}",
  form_submitted_message: "Your form was submitted successfully",
  required_fields_error: "Required values not entered",
  headphone_title: "Headphones",
  buy_button: "Buy",
  day: "day",
  hour: "hour",
  minute: "minute",
  second: "second",
  required_field_error: "{{fieldName}} is required",
  submit_request_button: "Submit Request",
  request_submitted_success: "Your request was registered successfully",
  feedback_submitted_success: "Your feedback was registered successfully",
  description_required_label: "Description (required)",
  description_optional_label: "Description (optional)",
  description_hint:
    "Please enter your desired description in this field (minimum 3 characters)",
  footer: {
    position: "Side",
    contactUs: "Contact Us",
    aboutUs: "About Us",
    firstShift: "First Shift",
    secondShift: "Second Shift",
    startTime: "Start Time",
    endTime: "End Time",
    features: "Features",
    partners: "Partners",
    affiliates: "Affiliate Programmes",
    panels: "Panels",
    supportTicket: "Support Ticket",
    inPersonServices: "In-Person Services",
    liveChat: "Live Chat",
    faq: "Frequently Asked Questions",
    add_secondshift: "Add Second Shift",
    firstDate: "Start Date",
    endDate: "End Date",
  },
  qr_management: "QR Management",
  restore_default_questions: "Restore default questions",
  delete_all: "Delete All",
  edit_question: "Edit Question",
  move_up: "Move Up",
  move_down: "Move Down",
  delete: "Delete",
  selected_question: "Selected Question",
  question: "Question",
  answer_type: "Answer Type",
  excellent: "Excellent",
  good: "Good",
  very_poor: "Very Poor",
  response_optionality: "Optional / Required Response",
  required: "Required",
  optional: "Optional",
  add_new_question: "Add New Question",
  satisfied_with_quality: "Were you satisfied with the quality of the goods?",
  evaluate_packaging_quality: "How do you evaluate the packaging quality?",
  satisfied_with_variety: "Were you satisfied with the variety of goods?",
  benefited_from_discounts: "Have you benefited from this shop's discounts?",
  suggestions_for_improvement:
    "What suggestion do you have to improve the shopping experience in this shop?",
  confirm_delete_question: "Delete selected question?",
  question_deleted_success: "Question deleted successfully.",
  question_delete_failed: "Error deleting question!",
  confirm_delete_all_questions:
    "Are you sure you want to delete all questions?",
  questions_deleted_success: "Questions deleted successfully.",
  questions_delete_failed: "Error deleting questions!",
  invalid_input: "Please enter values correctly!",
  operation_failed: "Operation failed!",
  question_number: "Question {number}?",
  card_subtitle:
    "Simply enter the story of your desired image, and AI will create it for you.",
  upgrade_label: "Attach",
  free: " - Free",
  language_select: "Select language for writing request text",
  image_size: "Image Size",
  prompt_label: "Request Text",
  prompt_placeholder: "Describe your desired image...",
  generate_image: "Generate Image",
  regenerate_image: "Generate New Image",
  save_image: "Save Image",
  save_image_subtitle: "Only the image displayed above will be saved.",
  size_items: {
    "16:9": "16:9 (horizontal)",
    "9:16": "9:16 (vertical)",
    "1:1": "1:1 (square)",
  },
  lang_items: {
    fa: "Fa | Persian",
    en: "En | English",
    ar: "Ar | Arabic",
  },
  rules: {
    empty: "At least 3 characters must be entered!",
    spell_checker: "Entered text must be in {language}!",
  },
  ERRORS: {
    VpnDetectedTitle: "Turn off your VPN",
    VpnDetectedSubtitle:
      "This helps the system work better and gives you a better experience.",
  },
  errors: {
    VpnDetectedTitle: "Turn off your VPN",
    VpnDetectedSubtitle:
      "This helps the system work better and gives you a better experience.",
    invalid_size: "Please enter width and height correctly!",
    image_generation_error: "Error in image creation",
    image_upload_error: "Image upload error!",
    service_unavailable:
      "This service is unavailable – loading data from the server encountered an error",
    qr_address_taken: "This QR address has already been taken",
  },
  add_working_time: "Add Working Time",
  selected_day: "Selected Day",
  range_name: "Time Range Name",
  add: "Add",
  first_shift: "First Shift",
  second_shift: "Second Shift",
  start_time: "Start Time",
  end_time: "End Time",
  date_range: "Date Range",
  all_week_days: "All Week Days",
  saturday_to_wednesday: "Saturday to Wednesday",
  saturday_to_thursday: "Saturday to Thursday",
  work_week: "All Week Days (except holidays)",
  feedbacks: "Feedbacks",
  failed_retrieve_feedback: "Failed to retrieve feedbacks!",
  province: "Province",
  search_city_placeholder: "Search for the desired city name.",
  search_city_label: "City Search",
  welcome: "Welcome to our app",
  description: "This is a multilingual app.",
  soon: "Coming soon",
  beta_version: "Beta version",
  defaults_cleared_success: "Default data cleared successfully",
  defaults_reset_success: "Default data reset successfully",
  select_navigator_after_location_click:
    "After clicking on the location, select the desired navigator",
  no_address_selected: "No address selected",
  no_location_selected: "No location selected",
  region: "Region",
  api_unauthorized: "Authentication error: Invalid API key",
  location_not_found: "Location not found",
  addCategory: "Add new category",
  editCategory: "Edit category",
  deleteCategory: "Delete selected category?",
  addProduct: "Add new product",
  saveProducts: "Select default products",
  addSubCategory: "Add subcategory",
  product: "Product",
  categoryName: "Category name",
  subCategoryName: "Subcategory name",
  confirmDeleteProduct: "Should the product be removed from the category?",
  successMessages: {
    categorySaved: "Categories successfully saved.",
    productSaved: "Products successfully saved.",
    productDeleted: "Product successfully deleted.",
  },
  errorMessages: {
    saveCategoryFailed: "Error saving categories!",
    saveProductFailed: "Error saving products!",
    deleteCategoryFailed: "Error deleting category!",
  },
  add_edit_categories: "Add/edit category",
  copy_category: "Copy category",
  product: "Product {point}",
  copy_product: "Copy product",
  add_edit_products: "Add/edit products",
  copy_category: "Copy category",
  edit_category: "Edit category",
  category_name: "Category name",
  edit_subcategory: "Edit subcategory",
  subcategory_name: "Subcategory name",
  add_new_category: "Add new category",
  store_management: "Shop management",
  manage_products: "Product management",
  products_export: "Download products",
  "UPLOAD_EXCEL.UPLOAD_TITLE": "Upload Excel file",
  "UPLOAD_EXCEL.DRAG_DROP_TEXT_PART1": "Drag your Excel file here or",
  "UPLOAD_EXCEL.DRAG_DROP_TEXT_PART2": "select it",
  "UPLOAD_EXCEL.DRAG_DROP_TEXT_PART3": "to upload",
  "UPLOAD_EXCEL.INVALID_FILE_TYPE": "Please upload only Excel files (.xlsx)",
  "GENERAL.SUBMIT": "Submit",
  "GENERAL.CANCEL": "Cancel",
  "GENERAL.SUCCESSFULLY_ADDED": "Products successfully uploaded",
  SUCCESSFULLY_DOWNLOADED: "Products successfully downloaded",
  "GENERAL.ERROR": "An error occurred",
  EditSubCategoty: "Edit subcategory",
  create: "Create",
  save_changes: "Save changes",
  buy_button_settings: "Buy button settings",
  image: "Image",
  color: "Colour",
  title: "Title",
  price: "Price",
  discount: "Discount",
  percent: "Percent",
  amount: "Amount",
  brand: "Brand",
  inventory: "Stock",
  inventory_hint: "Leave blank = unlimited order quantity",
  order_limit: "Max. quantity per order",
  order_limit_hint: "Leave blank = no limit.",
  packing_price: "Packing costs",
  packing_price_hint:
    "Applied for external orders (courier/on-site collection).",
  description: "Description",
  options: "Options",
  product_features: "Product features",
  field_required: "Required field.",
  min_length: "At least 3 characters required.",
  product: "Product",
  default_brand: "Apple",
  product_added_success: "Product successfully added",
  product_added_error: "Error adding product",
  whole_categories: "(All categories)",
  add_select_category: "Add/select category",
  select_default_category: "Select default category",
  deleted_product: "Delete product",
  confirm_delete_prooduct: "Should the product be removed from the category?",
  please_wait_store_product: "Products are being saved, please wait...",
  saved_product_success: "Products successfully saved.",
  error_in_store: "Error saving",
  delete_category: "Delete category",
  confirm_delete_category: "Category successfully deleted.",
  error_delete_category: "Error deleting category!",
  productOptionEditor: {
    tabs: {
      color: "Colour",
      size: "Size",
      count: "Quantity",
      weight: "Weight",
      type: "Type/Gender",
    },
    fields: {
      count: "Quantity",
      max_order: "Max. order quantity",
      price: "Price",
      discount: "Discount",
      color: "Colour",
      color_name: "Colour name",
      inventory: "Stock",
      size: "Size",
      type: "Type/Gender",
      weight: "Weight",
    },
    actions: {
      delete: "Delete",
      add_location: "Add option",
    },
  },
  extraSubProducts: {
    feature: "Feature",
    name_label: "Name",
    name_placeholder: "Example: Extra sauce / Additional bread",
    price_label: "Price",
    price_hint: "Leave blank = free add-on.",
    price_placeholder: "Example: Water, Type (e.g. chicken breast/thigh)",
    add_subproduct: "Add add-on product",
  },
  error_selected_category: "Error selecting category!",
  suggestinput: {
    title: "Select emoji",
    aboutUs: "About us",
    error: "Error",
    errorMessage: "Please top up your credit and try again.",
    generateText: "AI text suggestion",
    emoji: "Emoji",
    errorMessage_400: "Error creating 'About us' text. Please try again.",
    errorMessage_403:
      "Error creating 'About us' text. Purchase a package and try again",
  },
  togetherai: {
    buy_package: "Buy package",
    tax_notice: "10 % VAT will be added to the package price!",
    package: "Package",
    rial: "Rial",
    buy_button: "Buy!",
    discount_label: "Discount code",
    submit_discount: "Redeem",
    success_message: "Your QR has been successfully upgraded.",
    error_insufficient_funds: "Check your credit and try again later.",
    error_upgrade: "Error upgrading QR!",
    error_title: "Error",
    success_title: "Success",
  },
  category_not_found: "Category not found!",
  create_upload_category: "Create and upload category",
  add_subcategory: "Add subcategory",
  error_upload_m_video: "Error uploading video (possibly restricted access).",
  info_show_video: "Click 'More' to show more.",
  error_not_valid_guide_id: "Invalid guide ID!",
  error_give_guide_info: "Error retrieving guide information!",
  info_success_saved: "Successfully saved",
  error_add_new_guide: "Error adding new guide",
  popup: {
    details: "Details",
    guide_images: "Guide images",
    guide_videos: "Guide videos",
    faq: "FAQ",
    no_title: "No title",
    no_content: "No content to display",
    no_questions: "No question to display",
    video_error: "Error uploading video (possibly restricted access)",
    no_answer: "No answer",
    question_no_title: "Question without title",
    default_title: "Guide",
  },
  productPicker: {
    select_default_product: "Select default product",
    search: "Search",
    select_all_products: "Select all products",
    back: "Back",
    no_products_in_category: "No products in this category!",
    products_error: "Error loading products!",
    retry: "Try again",
    items_per_page: "Items per page",
    root_breadcrumb: "/",
  },
  end_date: "End date",
  filters: {
    userType: {
      legal: "Legal entity",
      individual: "Individual",
    },
    serviceType: {
      Payamakland: "Payamakland",
      Coreland: "Coreland",
      Qrland: "Qrland",
      Robotland: "Robotland",
      billboard: "Billboard",
      tablighNegar: "TablighNegar",
      unknown: "Unknown",
    },
    qrType: {
      gift: "Memory Frame",
      instagram: "Instagram",
      visitCard: "Business Card",
      Business: "Personal / Corporate",
      Commericial: "Commercial / Office Complex Website",
      qrlink: "QR Link",
      labelproduct: "Product Label",
      goldLabel: "Gold Label",
      bShop: "Store",
      SocialMedia: "Social Media",
      VideoGallery: "Video Gallery",
      PhotoGallery: "Photo Gallery",
      voiceGallery: "Audio Gallery",
      consultationQr: "Request Form",
      application: "Application",
      feedbackGallery: "Feedback",
      voiceGalleryPro: "Professional Audio Gallery",
      singleProduct: "Product Introduction",
      menu: "Menu",
      appointment: "Appointment Booking",
      insurance: "Insurance",
      text: "Text",
      luck_wheel: "Lucky Wheel",
      pdfgallery: "PDF Gallery",
      productpro: "Product Introduction Pro",
      multicard: "Multi Card",
      catalog: "Catalogue",
      visitCard_pro: "Pro Business Card",
      clickyarseo: "ClickYar SEO QR",
    },
    expire: {
      day: "Day",
      expired: "Expired",
    },
    numericPersianNumber: {
      thousand: "Thousand",
      million: "Million",
    },
    dateString: {
      at: "at",
    },
    messages: {
      pleaseLogin: "Please log in",
      invalidPhone: "Invalid phone number",
      copied: "Copied",
    },
  },
  nextButton: "Next",
  previousButton: "Previous",
  rowsPerPageText: "Items per page",
  noDataText: "No data to display",
  placeholderSearch: "Search..",
  set_qr: "QR registered",
  numbers: "Numbers",
  enter_param_product: "Enter product data correctly!",
  instagram_hint: "Enter your Instagram",
  whatsapp_hint: "Enter your WhatsApp",
  telegram: "Telegram",
  telegram_hint: "Enter your Telegram",
  userpicker: {
    select_user: "Select user",
    choice_users: "Select users",
    id: "ID",
    phone_number: "Mobile number",
    date_created: "Creation date",
    info_edit: "Edit information",
    name_family: "First and last name",
    position: "Position and rank",
    phone: "Phone number",
    discription: "Description",
  },
  search_product: "Search product",
  search_name_product: "Search product name",
  search_name_product: "Search product name",
  search_product: "Search product",
  currency: "Rial",
  headers: {
    index: "Order",
    gallery: "Image",
    id: "ID",
    name: "Name",
    brand: "Brand",
    price: "Amount",
    discount_amount: "Discount",
  },
  search_categories: "Search in categories",
  search_categories: "Search ",
  delete_all: "Delete all",
  select_category: "Select category",
  currency1: "Iranian Rial", // Currency unit Iran (Rial)
  features: "Features",
  product_sp: {
    edit: "Edit",
    back: "Back",
    save: "Save",
    add_product_to_special_category:
      "Fill in the fields to add the product to the special category",
    inventory: "Stock",
    discount: "Discount",
    max_per_customer: "Max. per customer",
    max_per_order: "Max. per order",
    expires_at: "Expiry date",
    field_cannot_be_empty: "Field cannot be empty.",
    please_enter_correctly: "Please fill in correctly!",
    currency: "Iranian Rial", // Currency unit Iran (Rial)
  },
  selectproduct: "Select product",
  section: {
    edit_part: "Edit section",
    title: "Title",
    position_text: "Text position",
    add_video: "Add video",
    text: "Text",
    address_video: "Video URL",
    position_left: "Left",
    position_right: "Right",
    tab_edit_button: "Edit button",
    tab_content: "Section content",
  },
  name_shopping: "Shop name",
  hint_shopping: "Enter your shop name.",
  title_discount: "Discount title",
  hint_discount: "Enter your discount title.",
  hint_mount_discount: " 20 % discount on your next order.",
  label_discount: "Enter discount amount",
  give_discount: "Get discount code",
  give_copon: "Get voucher",
  enter_copon: "Enter voucher",
  hint_phone: "Enter your phone number.",
  label_phone: "Phone number",
  hint_condition_discount: "Describe the discount conditions..",
  label_discription_discount: "Discount description",
  add_info_discount: "Add additional info:",
  enter_address_discount: "Enter your address.",
  address_discount: "Address",
  edit_feedback: "Edit feedback",
  select_type_replay: "Select reply type",
  field_discription: "Description field",
  messages_discription: "Enable this to show a description field for the user",
  number_char: "Character count must be between 3 and 50!",
  search: "Search",
  no_videos_found: "No videos found!",
  upload_video_prompt: "Use the video upload area to add a file",
  delete_success: "Successfully deleted.",
  tabs: {
    qr_view: "QR view",
    preview: "Preview",
    ready_video: "Ready video",
    video_gallery: "Video gallery",
    link: "Link",
    video_upload: "Upload video",
  },
  consultation: {
    name: "First name",
    surname: "Surname",
    phone: "Mobile number",
    nationalId: "National ID number",
    nationalIdAuthenticate: "Verify national ID",
    nationalIdCorrect: "Check validity of national ID number",
    mail: "Email",
    address: "Address",
    location: "Location",
    custom: "Custom",
    customLabel: "Title",
    customOptions: "Options",
    optional: "Optional",
    require: "Required",
    description: "Description",
  },
  add_section: "Add section",
  add_new_text_section:
    "You are warmly invited to the intelligent digital land of QR-Land.",
  btn_title_section: "Free registration",
  shop: {
    step_products_and_info: "Products & information",
    online_store_name: "Online shop name",
    qr_address: "QR address",
    qr_address_hint: "Enter your QR address",
    online_sale: "Online sale",
    step_content_settings: "Content settings",
    step_sale_settings: "Sale settings",
    download_qr: "Download QR",
    login_settings: "Login settings",
    store_logo_images: "Shop logo and images",
    login_page_info: "Login page information",
    upload_banner: "Upload banner",
    user_info: "User information",
    create_product: "Create product",
    special_sale: "Special sale",
    add_social_media: "Add social media",
    blog: "Blog",
    services: "Services",
    faq: "FAQ",
    photo_gallery: "Photo gallery",
    video_gallery: "Video gallery",
    pdf_gallery: "PDF gallery",
    feedback: "Feedback",
    countdown: "Countdown",
    request_form: "Request form",
    create_section: "Create section",
    achievements: "Achievements",
    team_members: "Team members",
    working_hours: "Opening hours",
    error_saving_content: "Error saving content settings!",
    success_edit_store: "Shop page successfully edited.",
    post_1: "Post 1",
    logo: "Logo",
    background_image: "Background image",
  },
  discount_obj: {
    quantity:"quantity",
    create_edit_code: "Create/edit discount code",
    coding_type_label: "Creation type",
    coding_type_single: "Single",
    coding_type_group: "Group",
    status_label: "Status",
    status_active: "Active",
    status_deactivate: "Deactivated",
    discount_code: "Discount code",
    discount_type: "Discount type",
    discount_type_percent: "Percentage",
    discount_type_fixed: "Fixed amount",
    discount_value: "Discount value",
    discount_limit: "Discount limit",
    no_limit: "No limit",
    tab_create_discount: "Create discount code",
    tab_settings: "Settings",
    success_create: "Discount code successfully created",
    success_edit: "Discount code successfully edited",
    error_value_empty: "Discount value cannot be empty!",
    error_start_time: "No start time selected!",
    error_end_time: "No end time selected!",
    error_same_time: "Start and end times cannot be the same",
  },
  personnel: {
    team_members: "Selected team members",
    add_team_member: "Add team member",
    default_position: "Position and rank",
    default_phone: "Phone number",
    default_full_name: "Full name",
    default_description:
      "Lorem Ipsum is simply dummy text of the printing industry, used by designers for centuries",
  },
  discount_settings: {
    function_type: {
      title: "Discount function",
      all_shopping_cart: "Total shopping basket amount",
      special_products: "Special products",
      special_categories: "Special categories",
    },
    basket_condition: {
      title: "Basket conditions",
      no_conditions: "No conditions",
      minimum_shopping: "Minimum basket amount",
      minimum_product: "Minimum products in basket",
      maximum_shopping: "Maximum basket amount",
      maximum_product: "Maximum products in basket",
    },
    user_settings: {
      title: "User settings",
      all_user: "All users",
      group: "User group",
      special: "Special users",
    },
    limitation_use: {
      title: "Usage limitation",
      no_limitations: "No limitations",
      discount_code: "Number of discount code uses",
      user: "Uses per user",
    },
    start_time: {
      title: "Discount start date",
      no_time_selected: "No start time selected",
    },
    end_time: {
      title: "Discount end date",
      no_time_selected: "No end time selected",
    },
  },
  counterService: {
    typeLabel: "Display type",
    number: "Number",
    percent: "Percent",
    iconLabel: "Icon",
    counterLabel: "Value",
    linkLabel: "Link",
    nameLabel: "Title",
    addButton: "Add success",
    successful: {
      added: "Item successfully added",
      removed: "Item successfully removed",
      movedUp: "Item successfully moved up",
      movedDown: "Item successfully moved down",
    },
  },
  qrUsersList: {
    customersList: "Customers list",
    orders: "Orders",
    addresses: "Addresses",
    hasAssistantsMobile_hint: "Select mobile",
    invalidPhone: "The entered mobile number is not valid",
    validation: {
      nameRequired: "Entering a name is required",
      nameMinLength: "Name must be at least 2 characters",
      familyRequired: "Entering a family name is required",
      familyMinLength: "Family name must be at least 2 characters",
    },
    addUser: "Add User",
    registerOnline: "Enable online registration",
    usersColumns: {
      id: "ID",
      name: "First name",
      family: "Surname",
      mobile: "Mobile",
      subscriptionId: "Subscription ID",
      ordersCount: "Order count",
      lastLogin: "Last login",
      status: "Status",
      activeUser: "Active user",
      none: "-",
      actions: "Actions",
      buttons: {
        info: "Customer data",
        sendSms: "Send SMS",
        history: "History",
        addresses: "Addresses",
        orders: "Orders",
      },
    },
    orderColumns: {
      orderId: "Order number",
      customerName: "Customer name",
      mobile: "Mobile",
      paymentMethod: "Payment method",
      shippingMethod: "Shipping method",
      orderAmount: "Order amount",
      orderTime: "Order time",
      status: "Status",
      currency: "Rial",
    },
    addressesColumns: {
      id: "#",
      addressTitle: "Address title",
      name: "First name",
      family: "Surname",
      mobile: "Phone",
      address: "Address",
      zipCode: "Postcode",
      number: "House number",
      unit: "Unit",
    },
    shippingType: {
      courier: "Courier",
      reservation: "Table reservation",
      place: "On-site collection",
      none: "-",
    },
    paymentType: {
      online: "Online payment",
    },
    perPage: "Items per page",
    search: "Search",
    sortColumn: "Sort by",
    sortDirection: "Sort direction",
    sortDirectionDesc: "Descending",
    sortDirectionAsc: "Ascending",
    noStatus: "No status found",
    status: {
      all: "All",
      active: "Active",
      inactive: "Inactive",
    },
    fetchError: "Error loading user data",
  },
  listCardHeader: {
    clear_filters: "Clear filters",
    group_qr_renewal: "Bulk QR code renewal",
    select_desired_duration: "Select desired duration",
    total_count: "Total count",
    final_amount: "Final amount",
    ten_percent_vat_will_be_added: "10 % VAT will be added",
    pay_and_upgrade: "Pay & upgrade",
    no_tariff_for_this_period: "No tariffs for this period",
    one_month_renewal: "1-month renewal",
    three_month_renewal: "3-month renewal",
    six_month_renewal: "6-month renewal",
    one_year_renewal: "1-year renewal",
    selected: "Selected",
    view: "View",
    details: "Details",
    total_amount: "Total amount",
    discount: "Discount",
    final_amount_with_discount: "Final amount with discount",
    add_qr: "Add QR",
    select_all: "Select all",
    actions: "Actions",
    filter: "Filter",
    type_filter: "Type filter",
    start_from: "Starts with",
    search: "Search",
    id_search: "ID search",
    filter_user: "User filter",
    sort: "Sort",
    send_sms: "Send SMS",
    selected_pattern: "Selected pattern:",
    send: "Send",
    newest: "Newest",
    oldest: "Oldest",
    most_visited: "Most visited",
    least_visited: "Least visited",
    pause: "Pause",
    bulk_download: "Bulk download",
    activate: "Activate",
    deactivate: "Deactivate",
    error_loading_card: "Error loading card data!",
    error_fetching_prices: "Error fetching prices!",
    error_payment: "Payment error!",
    sms_success: "SMS successfully sent",
    generic_error: "An error occurred!",
  },
  headerTypeFilter: {
    qr_model: "QR model",
    all_qr_models: "All QR models",
  },
  menuOrderFactor: {
    order_invoice: "Order invoice",
    total: "Total",
    tax: "Tax",
    shipping_cost: "Shipping costs",
    packing_cost: "Packing costs",
    discount: "Discount",
    final_total: "Final total",
    currency: "Rial",
    titles: {
      default_title: "Standard order",
    },
  },
  headerSearchTypeFilter: {
    search_in_list: "Search in list",
    search: "Search",
    start_from: "Starts with",
  },
  headerStatusFilter: {
    all_qr_codes: "All QR codes",
    active_qr_codes: "Active QR codes",
    inactive_qr_codes: "Inactive QR codes",
    expiring_qr_codes: "Soon expiring QR codes",
    expired_qr_codes: "Expired QR codes",
  },
  qrOrdersList: {
    title: "Orders list",
    orderColumns: {
      index: "Order",
      id: "Order number",
      customerName: "Customer name",
      mobile: "Mobile",
      paymentType: "Payment type",
      shippingType: "Shipping type",
      price: "Order amount",
      createdAt: "Order time",
      status: "Status",
      actions: "Actions",
    },
    productsColumns: {
      productId: "Product ID",
      image: "Image",
      productName: "Product name",
      unitPrice: "Unit price",
      quantity: "Quantity",
      totalPrice: "Total price",
    },
    actions: {
      products: "Order list",
      print: "Print order",
      share: "Share order",
      status: "Change status",
    },
    shippingType: {
      courier: "Courier",
      reservation: "Table reservation",
      place: "On-site collection",
      post: "Postal delivery",
      unknown: "-",
    },
    paymentType: {
      online: "Online payment",
      place: "Payment on site",
      card2card:"Card to Card Payment",
      unknown: "-",
    },
    status: {
      all: "All",
      pending: "Payment pending",
      accepted: {
        place: "Payment on site",
        paid: "Paid",
      },
      delivered: "Delivered",
      rejected: "Payment failed",
    },
    factorTitle: "Order invoice",
    printFactor: "Print invoice",
    fetchError: "Error loading data",
    statusChanged: "Status successfully changed",
    statusChangeError: "Error changing status",
    currency: "Rial",
    perPage: "Count",
    search: "Search",
    noStatus: "No status",
    loading: "Loading...",
    noShippingType: "No shipping type",
    noPaymentType: "No payment type",
    sortColumn: "Sort column",
    sortDirection: "Sort direction",
    sortDirectionDesc: "Descending",
    sortDirectionAsc: "Ascending",
    selectNewStatus: "Select new status",
    changeStatusTitle: "Change status",
    linkCopied: "Link copied.",
  },
  qrUserTransfer: {
    title: "Ownership transfer",
    radioLabels: {
      userTransfer: "Transfer to another person",
      givingAccess: "Grant access",
    },
    inputLabels: {
      phone: "Person's mobile number",
    },
    hints: {
      addNumber: "Press Enter or + to add",
      addNumberStep2: "Press Enter or + to add",
    },
    buttons: {
      transfer: "Transfer",
      giveAccess: "Grant access",
      back: "Back",
      saveChanges: "Save changes",
      cancel: "Cancel",
        "add": "Add"
    },
    tooltips: {
      deleteAccess: "Remove access",
    },
    subtitles: {
      accessList: "List of authorised users:",
      selectPermissions: "Select permissions:",
    },
    permissionList: {
      edit_name: "Edit service name",
      edit_link: "Edit link",
      edit_info: "Edit information",
      edit_design: "Edit QR design",
      edit_settings: "Edit QR settings",
      toggle_access: "Enable/disable access",
      view_customers: "View customers list",
      view_orders: "View orders list",
    },
    messages: {
      invalidPhone: "Invalid phone number",
      duplicatePhone: "Duplicate number not allowed",
      updateAccessSuccess: "Access successfully updated.",
      updateAccessError: "Error updating: {message}",
      deleteAccessSuccess: "Access successfully removed.",
      deleteAccessError: "Error removing: {message}",
      fetchAccessError: "Error loading: {message}",
      transferSuccess: "QR successfully transferred.",
      transferError: "Transfer error: {message}",
      giveAccessSuccess: "Successfully set up.",
      giveAccessError: "Setup error: {message}",
      confirmDeleteAccess: "Really remove this person's access?",
    },
  },
  form: {
    form_download: "Received forms",
    form_add: "Add form",
    formdownload: "Received form",
    create_at: "Created at :",
    shown: "Shown",
    nogiveform: "You have no received form",
    back: "Back",
    invalid_date: "Invalid date",
    select_date: "Select date",
    select: "Select",
    clear: "Clear",
    now: "Now",
  },
  dsBasketCondition: {
    title: "Minimum basket conditions",
    items: {
      NoConditions: "No conditions",
      MinimumShopping: "Minimum basket amount",
      MinimumProduct: "Minimum products in basket",
      MaximumShopping: "Maximum basket amount",
      MaximumProduct: "Maximum products in basket",
    },
  },
  dsUserSettings: {
    title: "Minimum basket conditions",
    groupTitle: "Users who",
    specialTitle: "Users",
    labels: {
      minimumCart: "Minimum basket conditions",
      users: "Users",
    },
    items: {
      AllUser: "All users",
      group: "User group",
      special: "Special users",
    },
    groupItems: {
      Order: "Have already purchased",
      noOrder: "Have not purchased yet",
    },
  },
  qrAddressUpdate: {
  title: "Edit Address",
  labels: {
    address: "QR Address",
  },
  hints: {
    allowedChars: "Only English letters, numbers, hyphens (-), and underscores (_) are allowed",
  },
  buttons: {
    removeInvalidChars: "Remove Invalid Characters",
  },
  errors: {
    minLength: "At least 3 characters are required",
    invalidChars: "Invalid character! Use only English letters, numbers, - and _.",
    invalidAddress: "The entered address is invalid",
    updateFailed: "Failed to update the address",
  },
  successMessage: "Address updated successfully",
  warning: "Warning",
  warningMessage: "Changing the address will make previous links stop working.",
  savePrompt: "Are you sure you want to save this change?",
},
  dsFunctionType: {
    title: "Discount applies to",
    productListTitle: "Product list",
    categoryListTitle: "Category list",
    labels: {
      applyDiscount: "Apply discount to",
      category: "Category",
    },
    items: {
      AllShoppingCart: "Total shopping basket amount",
      SpecialProducts: "Special products",
      SpecialCategories: "Special categories",
    },
  },
  dsLimitationUse: {
    title: "Usage limitation",
    discountCodeTitle: "Code uses",
    userTitle: "Uses per user",
    labels: {
      limitation: "Limitation",
      usage: "Usage",
      user: "User",
    },
    items: {
      NoLimitations: "No limitations",
      DiscountCode: "Discount code uses",
      User: "Uses per user",
    },
  },
  ManageHourLimitQr: {
    noLimit: "No limit",
    dateLimit: "Date limit",
    timeLimit: "Time limit",
    startDate: "Start date",
    endDate: "End date",
    selectDate: "Select date",
    startTime: "Start time",
    endTime: "End time",
  },
  discount_percent_range: "Discount must be between 0 and 100 %",
  discount_price_range: "Discount must be between 0 and {max}",
  invalid_number: "Enter numbers only",
  min_order_cart: "Minimum order value",
  preparation_time: "Preparation time (minutes)",
  delivery_time: "Delivery time (minutes)",
  max_product_in_order: "Max. products per order",
  max_order_by_person: "Max. orders per person",
  send_by_courier_price: "Courier costs",
  vat: "Tax rate",
  send_by_post: "Postal delivery costs",
  online_pay: "Online payment",
  pay_in_person_place: "Payment on site",
  in_place: "On-site collection",
  table_booking_ability: "Table booking",
  send_by_courier: "Courier delivery",
  vat_switch: "Tax",
  invalid_number: "Enter numbers only",
  positive_number: "Number must be positive",
  vat_range: "Tax rate must be between 0 and 100 %",
  sort_column: "Sort column",
  direction_sort: "Sort direction",
  listFeedbackUser: {
    no_questions: "You have no questions for feedback collection",
    add_feedback_prompt: "Create new feedback in the 'Add' tab",
    question_label: "Question",
    show_answers: "Show answers",
    back_button: "Back",
    no_feedback: "No feedback available!",
    user_opinion: "User opinion",
    score_label: "Rating",
  },
  manageDiscount: {
    createNewDiscount: "Create new discount code",
    copy: "Copy",
    row: "Row",
    id: "ID",
    discountCode: "Discount code",
    usageLimit: "Usage limit",
    used: "Used",
    manage: "Manage",
    edit: "Edit",
    delete: "Delete",
    sendSms: "Send SMS to target group",
    copySuccess: "Discount code copied",
    copyError: "Error copying",
    deleteSuccess: "Discount code deleted",
    deleteError: "Error deleting discount code",
    smsSuccess: "Discount code sent to target group",
    smsError: "Error sending",
  },
  manageTableReservation: {
    table: "Table",
    number: "Table {num}",
    add_table: "Add table",
    complete_info_for_customer: "Fill in the info to be shown to the customer",
    select_image: "Select image",
    table_name_number: "Table name/number",
    number_of_seats: "Number of seats",
    type: "Type",
    reservation_cost: "Reservation cost",
    enter_table_name: "Enter table name/number",
    table_type: "Table",
    couch_type: "Sofa",
    gazebo_type: "Gazebo",
  },
  create_menu: {
    data: {
      visitName_label: "Visit name",
      organizationName: "Large fast-food chain",
      subOrgan: "Try the best fast-food taste with us",
      aboutUs:
        "Large Fast-Food – with quality and respect for the customer, we offer the best.\nQuality is our principle.\nIn the fast-food sector, we have introduced a new taste to the world of quick meals with our special sandwiches\nWe are ready every day to serve you at administrative events, birthdays and more...",
      copyright: "All rights of this website belong to Terminal Advertising.",
      product: {
        title: "Products",
        pizzas: "Pizzas",
        pizza_roast_beef: "Pizza Roast Beef",
        pizza_roast_beef_desc: "🤩 Italian pizza with beef",
        pizza_roast_beef_ingredients:
          "Italian pizza base 30 cm, 100 g minced beef, mushrooms, peppers, black olives",
        pizza_chicken_mushroom: "Pizza Chicken & Mushrooms",
        pizza_chicken_mushroom_desc: "🍕 Classic 40 cm",
        pizza_chicken_mushroom_ingredients:
          "Fresh Pizzara tomato sauce, cheese (pasteurised), chicken fillet, mushrooms, mountain thyme",
        pizza_meat_mushroom: "Pizza Meat & Mushrooms",
        pizza_meat_mushroom_desc: "🥰 Pizza with minced beef and mushrooms",
        pizza_meat_mushroom_ingredients:
          "Fresh Pizzara tomato sauce, cheese (pasteurised), beef topside mince, mushrooms, mountain thyme, for 2 people (29 cm) 355.000 Toman, for 1 person (22 cm) 216.000 Toman",
        pizza_veggie: "Veggie Pizza",
        pizza_veggie_desc: "🍕 American veggie pizza",
        pizza_veggie_ingredients:
          "American pizza base, sweetcorn, mushrooms, olives, tomatoes, onions, peppers, pizza cheese",
        pizza_special: "Special Pizza",
        pizza_special_desc: "American special pizza",
        pizza_special_ingredients:
          "American pizza base, seasoned minced beef, hamburger mix beef & chicken 80 %, mozzarella mix, special sauce, peppers, mushrooms, no sauce for 1 person",
        pizza_bolognese: "Pizza Bolognese",
        pizza_bolognese_desc: "(For 1 person) Pizza base 23 cm 🤌",
        pizza_bolognese_ingredients:
          "Minced beef, mozzarella, mushrooms, peppers, sweetcorn, black olives in slices",
        pizza_pepperoni: "Pizza Pepperoni",
        pizza_pepperoni_desc: "(For 1 person) Pizza base 23 cm",
        pizza_pepperoni_ingredients:
          "Italian pizza base, pepperoni 80 %, marinara sauce, special pizza cheese",
        pizza_bacon: "Pizza Bacon",
        pizza_bacon_desc: "(For 1 person) Pizza base 23 cm 💥",
        pizza_bacon_ingredients:
          "Italian pizza base, marinara sauce, special pizza cheese, bacon mix beef & chicken 90 %, mushrooms, olives, peppers",
        pizza_mixed: "Mixed Pizza",
        pizza_mixed_desc: "(For 1 person) Pizza base 23 cm 🤭",
        pizza_mixed_ingredients:
          "Hamburger mix beef & chicken minced, salami, minced beef, mushrooms, olives, peppers, pizza cheese, special sauce",
        pizza_american_steak: "American Steak Pizza",
        pizza_american_steak_desc: "(For 1 person) 23 cm 💥",
        pizza_american_steak_ingredients:
          "American pizza base, beef pieces, mushrooms, pizza cheese, sesame",
        burgers: "Burgers",
        cheeseburger: "Cheeseburger",
        cheeseburger_desc: "🤩 With chips",
        cheeseburger_ingredients:
          "2 beef burger patties à 150 g, special sauce, Gouda cheese, gherkin, lettuce, tomato",
        hamburger: "Hamburger",
        hamburger_desc: "😍 Pure beef with special sauce",
        hamburger_ingredients:
          "Beef burger patty 150 g, gherkin, lettuce, special sauce, tomato, Mac bun, sauce for 1 person",
        chicken_burger: "Chicken Burger",
        chicken_burger_desc: "Grilled chicken with cheese",
        chicken_burger_ingredients:
          "150 g grilled chicken breast, cheese, tomato, gherkin, lettuce, Mac bun, special sauce",
        spice_burger: "Spicy Burger",
        spice_burger_desc: "Beef with spicy sauce",
        spice_burger_ingredients:
          "Beef burger patty 130 g, spicy sauce, lettuce, tomato, Mac bun, special spicy sauce",
        double_burger: "Double Burger",
        double_burger_desc: "Beef 150 g",
        double_burger_ingredients:
          "2 handmade beef patties à 150 g, pizza cheese, caramel sauce, lettuce, red cabbage, white special sauce, round bun",
        royal_burger: "Royal Burger",
        royal_burger_desc: "150 g beef 🍔",
        royal_burger_ingredients:
          "Handmade beef patty 150 g, pizza cheese, 5 slices salami, caramel sauce, lettuce, red cabbage, white special sauce, round bun",
        mushroom_burger: "Mushroom Burger",
        mushroom_burger_desc: "Beef 150 g",
        mushroom_burger_ingredients:
          "Handmade beef patty 150 g, mushrooms, caramel sauce, lettuce, red cabbage, white special sauce, round bun, mozzarella",
        mashroom_burger: "Mushroom Burger",
        mashroom_burger_desc: "100 % grilled beef 🤩",
        mashroom_burger_ingredients:
          "Handmade 100 % grilled beef patty, chips, tomato, lettuce, gherkin, mushroom sauce, round bun",
        fried_burger: "Fried Burger",
        fried_burger_desc: "100 % grilled & fried beef 👌",
        fried_burger_ingredients:
          "Handmade 100 % grilled & fried beef patty, 150 g chips, tomato, lettuce, gherkin, special sauce, round bun",
        fried: "Fried",
        fried_chicken: "Fried Chicken",
        fried_chicken_desc: "😍 3 pieces fried chicken",
        fried_chicken_ingredients:
          "3 pieces fried chicken, 120–150 g chips, 100–120 g coleslaw, bread roll, special sauce",
        chicken_strips: "Chicken Strips",
        chicken_strips_desc: "4 pieces seasoned spicy fried chicken fillet",
        chicken_strips_ingredients:
          "4 pieces fried chicken fillet, 120–150 g chips, 100–120 g coleslaw, bread roll, tartar sauce",
        fried_filet: "Fried Fillet",
        fried_filet_desc: "🤩 2 pieces fried fillet with special sauce",
        fried_filet_ingredients:
          "2 pieces strips, grilled potatoes, coleslaw, bread roll, garlic sauce, Thai chilli sauce, paprika sauce",
        fried_mushroom_onion: "Fried Mushrooms & Onions",
        fried_mushroom_onion_desc:
          "🤩 Fried mushrooms & onions with tartar sauce",
        fried_mushroom_onion_ingredients:
          "20 pieces fried mushrooms, 6 pieces fried onion rings, tartar sauce",
        fried_wings: "Fried Wings",
        fried_wings_desc: "6 pieces fried wings 🍗",
        fried_wings_ingredients: "Six grilled & fried wings",
        fried_chicken_basket: "Fried Chicken Basket",
        fried_chicken_basket_desc: "(For 2 people) 😍",
        fried_chicken_basket_ingredients:
          "2 pieces fried chicken, 2 pieces strips, 2 pieces onion rings, 2 pieces fried prawn nuggets, 2 pieces chicken nuggets",
        fried_schnitzel: "Fried Schnitzel",
        fried_schnitzel_desc: "Four pieces chicken schnitzel 💥",
        fried_schnitzel_ingredients:
          "Four grilled & fried seasoned chicken schnitzels",
        veggie_basket_fried: "Fried Veggie Basket",
        veggie_basket_fried_desc: "250 g 🤩",
        veggie_basket_fried_ingredients:
          "250 g, fried courgette, aubergine, mushrooms, potatoes",
        fried_chicken_2_piece: "Fried Chicken 2 Pieces",
        fried_chicken_2_piece_desc: "2 pieces fried chicken 🍗",
        fried_chicken_2_piece_ingredients:
          "120–150 g chips, 100–120 g coleslaw, bread roll, special sauce",
        fried_chicken_5_piece: "Fried Chicken 5 Pieces",
        fried_chicken_5_piece_desc: "Five pieces fried chicken",
        fried_chicken_5_piece_ingredients:
          "150–200 g chips, two coleslaws 100–120 g, two bread rolls, special sauce",
        fried_chicken_7_piece: "Fried Chicken 7 Pieces",
        fried_chicken_7_piece_desc: "Seven pieces fried chicken 💥",
        fried_chicken_7_piece_ingredients:
          "150–200 g chips, coleslaw 100–120 g, 3 bread rolls, special sauce, sauce for 1 person fried",
        sandwich: "Sandwich",
        hotdog_sandwich: "Hotdog Sandwich",
        hotdog_sandwich_desc: "Hotdog sandwich with mushrooms and cheese",
        hotdog_sandwich_ingredients:
          "Grilled hotdog sausage, lettuce, tomato, gherkin, mushrooms and pizza cheese",
        roast_beef_sandwich: "Roast Beef Sandwich",
        roast_beef_sandwich_desc: "✔️ Minced beef",
        roast_beef_sandwich_ingredients:
          "Beef, pizza cheese, mushrooms, potato crisps in slices, lettuce, tomato, gherkin, special sauce, French bread",
        ham_sandwich: "Ham Sandwich",
        ham_sandwich_desc: "Chicken ham sandwich with mushrooms (cold)",
        ham_sandwich_ingredients:
          "Chicken ham with mushrooms, lettuce, tomato, gherkin, potato crisps in slices, special sauce, baguette",
        bandari_sausage_sandwich: "Bandari Sausage Sandwich",
        bandari_sausage_sandwich_desc: "💥 Spicy Bandari sandwich",
        bandari_sausage_sandwich_ingredients:
          "Bandari food with smoked cocktail sausage 55 %, tomato, gherkin, special sauce, onion and coriander, bulky bread",
        tongue_mushroom_sandwich: "Tongue & Mushroom Sandwich",
        tongue_mushroom_sandwich_desc: "150 g beef tongue",
        tongue_mushroom_sandwich_ingredients:
          "Mushrooms, pasteurised pizza cheese, olives, sweetcorn, lettuce, gherkin, tomato, sauce, sides, chips, coleslaw",
        falafel_sandwich: "Falafel Sandwich",
        falafel_sandwich_desc: "Six pieces falafel 🌭",
        falafel_sandwich_ingredients:
          "Six pieces falafel, gherkin, tomato, lettuce, sauce for 1 person, sides, chips, coleslaw",
        cheesy_kebab_turki_sandwich: "Cheesy Turkish Kebab Sandwich",
        cheesy_kebab_turki_sandwich_desc: "150 g beef",
        cheesy_kebab_turki_sandwich_ingredients:
          "150 g beef, special pizza cheese, gherkin, tomato, lettuce, sauce for 1 person, chips, coleslaw",
        roast_chicken_sandwich: "Grilled Chicken Sandwich",
        roast_chicken_sandwich_desc: "Chicken schnitzel and mushrooms 🤩",
        roast_chicken_sandwich_ingredients:
          "Chicken schnitzel and mushrooms, special pizza cheese, olives, sweetcorn, sesame, lettuce, peppers, gherkin, tomato, special sauce, sides, chips",
        cheesy_indian_sandwich: "Indian Cheesy Sandwich",
        cheesy_indian_sandwich_desc: "German sausage 💥",
        cheesy_indian_sandwich_ingredients:
          "German cheese sausage, sweetcorn, lettuce, mushrooms, special sauce, sides, chips, coleslaw",
        snack: "Snack",
        chicken_snack: "Chicken Snack",
        chicken_snack_desc: "😋 Minced chicken breast",
        chicken_snack_ingredients:
          "150 g chicken breast, peppers, mushrooms, special snack bread, special sauce",
        meat_snack: "Meat Snack",
        meat_snack_desc: "🥪 Double meat snack",
        meat_snack_ingredients:
          "Double, beef topside mince, mozzarella, sweetcorn, peppers, special sauce, toast bread",
        chicken_meat_snack: "Chicken-Meat Snack",
        chicken_meat_snack_desc: "🤩 Double chicken-meat snack",
        chicken_meat_snack_ingredients:
          "Double, minced chicken breast, beef topside mince, mozzarella, sweetcorn, peppers, special sauce, toast bread",
        special_snack: "Special Snack",
        special_snack_desc: "🤤 Double special snack",
        special_snack_ingredients:
          "Double, kalbas mix beef & chicken 90 %, mozzarella, sweetcorn, peppers, special sauce, toast bread",
        roast_beef_snack: "Roast Beef Snack",
        roast_beef_snack_desc: "Minced beef 🍖",
        roast_beef_snack_ingredients:
          "Minced beef, mushrooms, pizza cheese, peppers, sweetcorn, sides, chips, coleslaw",
        veggie_snack: "Veggie Snack",
        veggie_snack_desc: "4 pieces veggie snack",
        veggie_snack_ingredients:
          "Broccoli, sweetcorn, olives, diet pizza cheese, mushrooms, sides, chips, coleslaw",
        chicken_mushroom_snack: "Chicken & Mushroom Snack",
        chicken_mushroom_snack_desc: "Chicken schnitzel and mushrooms 👌",
        chicken_mushroom_snack_ingredients:
          "Chicken schnitzel, mushrooms, special pizza cheese, olives, sweetcorn, peppers, sides, chips, coleslaw",
        pepperoni_snack: "Pepperoni Snack",
        pepperoni_snack_desc: "Kalbas pepperoni 90 % 💥",
        pepperoni_snack_ingredients:
          "Double, kalbas pepperoni 90 %, mozzarella, sweetcorn, peppers, special sauce",
        bologna_snack: "Bologna Snack",
        bologna_snack_desc: "Minced beef 👌",
        bologna_snack_ingredients:
          "Double, minced beef, special bacon, bleached mushrooms, sweetcorn, mozzarella, peppers, special sauce",
        pasta: "Pasta",
        alfredo_pasta: "Alfredo Pasta",
        alfredo_pasta_desc: "Alfredo pasta with special mushroom sauce",
        alfredo_pasta_ingredients: "350 g penne",
        macaroni: "Macaroni",
        macaroni_desc: "🥣 Macaroni with meat and mushrooms",
        macaroni_ingredients:
          "Ribbon noodles 1,2, 100 g minced beef, mushrooms, peppers, diced grilled potatoes, peas",
        spaghetti_bolognese: "Spaghetti Bolognese",
        spaghetti_bolognese_desc: "🥰 Linguine pasta",
        spaghetti_ingredients:
          "700 g, linguine pasta, beef and lamb mince, bolognese sauce, special red Rasu sauce, plastic spoon and fork after choice",
        chicken_stroganoff: "Chicken Stroganoff",
        chicken_stroganoff_desc:
          "😍 Chicken stroganoff with chicken breast pieces",
        chicken_stroganoff_ingredients:
          "180 g seasoned chicken breast pieces, cream, bleached mushrooms, parmesan, hand-cut chips, special microwave container",
        penne_arrabbiata: "Penne Arrabbiata",
        penne_arrabbiata_desc: "Chicken breast 💥",
        penne_arrabbiata_ingredients:
          "For 1 person, chicken breast, pasta, mushrooms, parmesan, cherry tomatoes, parsley, arrabbiata sauce",
        chicken_pesto_pasta: "Chicken Pesto Pasta",
        chicken_pesto_pasta_desc: "(For 1 person) Chicken breast",
        chicken_pesto_pasta_ingredients:
          "Chicken breast, mushrooms, parmesan, cherry tomatoes, parsley, arrabbiata sauce",
        carbonara_pasta: "Carbonara Pasta",
        carbonara_pasta_desc: "Beef bacon 97 %",
        carbonara_pasta_ingredients:
          "Pasta, beef bacon 97 %, alfredo sauce, parmesan, cherry tomatoes, parsley",
        appetizer: "Appetisers",
        hot_chips: "Hot Chips",
        hot_chips_desc: "😙 Various chip flavours",
        hot_chips_ingredients:
          "Kilo chips, special sauce, chicken ham 70 %, mushrooms, peppers, pizza cheese, Gouda",
        lasagna: "Lasagne",
        lasagna_desc: "Lasagne with minced beef",
        lasagna_ingredients:
          "3 lasagne sheets, minced beef, mushrooms, peppers, black olives, pizza cheese, special sauce",
        french_fries: "Chips",
        french_fries_desc: "Chips with special sauce",
        french_fries_ingredients: "150g chips, special sauce",
        baked_potato: "Jacket Potato",
        baked_potato_desc: "🍟 Jacket potato with beef bacon",
        baked_potato_ingredients:
          "150g chips, beef bacon 90%, pizza cheese, special seasoning, single serving sauce",
        garlic_bread: "Garlic Bread",
        garlic_bread_desc: "Special garlic sauce💥",
        garlic_bread_ingredients:
          "American pizza dough, mixed pizza cheese, special garlic sauce, sesame seeds",
        silo_potatoes: "Silo Potatoes",
        silo_potatoes_desc: "Chips for two",
        silo_potatoes_ingredients:
          "Silo seasoned chips, beef bacon 97%, cheddar sauce, aioli, spring onion, parsley",
        bbq_sausage: "BBQ Sausage",
        bbq_sausage_desc: "Marinated finger sausage🍢",
        bbq_sausage_ingredients:
          "500g seasoned mashed potato, 200g marinated finger sausage, onion rings, green olives, parmesan cheese powder, cherry tomatoes, microgreens, grillable cheese, BBQ sauce, spicy",
        silo_toast: "Silo Toast",
        silo_toast_desc: "160g beef sirloin slices🤩",
        silo_toast_ingredients:
          "160g beef sirloin slices, French lettuce, beef bacon, farmhouse bread, BBQ sauce, tartare sauce, sorrel, green olives, microgreens, aioli, parmesan cheese powder",
        salad_and_dessert: "Salad and Dessert",
        caesar_salad: "Caesar Salad",
        caesar_salad_desc: "Single serving Caesar salad🥗",
        caesar_salad_ingredients:
          "Mixed lettuce, grilled chicken, parmesan cheese, croutons (garlic bread), Caesar dressing, olives",
        caesar_salad_extra: "Romaine lettuce, croutons, parmesan",
        coleslaw_salad: "Coleslaw",
        coleslaw_salad_desc: "Single serving coleslaw🍴",
        coleslaw_salad_ingredients:
          "Handmade, single serving, white cabbage, sweetcorn, sauce",
        macaroni_salad: "Macaroni Salad",
        macaroni_salad_desc: "Macaroni salad with homemade ham",
        macaroni_salad_ingredients: "Macaroni, homemade ham",
        pachira_salad: "Pachira Salad",
        pachira_salad_desc: "Pachira salad for two🥗",
        pachira_salad_ingredients:
          "For two, mixed lettuce, beef bacon crisps 98%, caramelised walnuts, parmesan cheese, strawberries, vegetable caviar, raisins, lemon slices, rose berry sauce",
        greek_salad: "Greek Salad",
        greek_salad_desc: "Traditional Greek salad with feta cheese and olives",
        greek_salad_ingredients: "Feta cheese, olives, cucumber",
        tiramisu: "Tiramisu",
        tiramisu_desc: "Classic Italian tiramisu dessert",
        tiramisu_ingredients: "Coffee, mascarpone, cocoa",
        beverages: "Beverages",
        local_yogurt_drink: "Local Yoghurt Drink",
        local_yogurt_drink_desc: "Family-style local yoghurt drink🥛",
        local_yogurt_drink_ingredients: "",
        black_soda: "Black Fizzy Drink",
        black_soda_desc: "Glass of black fizzy drink🧋",
        black_soda_ingredients: "",
        fanta: "Yellow Fizzy Drink",
        fanta_desc: "Glass of yellow fizzy drink🥤",
        fanta_ingredients: "",
        mojito: "Mojito",
        mojito_desc: "Glass of mojito, 350 to 400 ml🍸",
        mojito_ingredients: "",
        tropical_malt_beverage: "Tropical Malt Beverage",
        tropical_malt_beverage_desc: "Glass of tropical malt beverage🍺",
        tropical_malt_beverage_ingredients: "",
      },
      socialMedia: {
        address_label: "Address",
        address_text: "Enter the link to the desired website",
        instagram_label: "Instagram",
        instagram_text: "Enter your username",
        whatsapp_label: "WhatsApp",
        whatsapp_text: "+989123456789",
      },
      videoGallery: {
        title: "Video Gallery",
        description:
          "To learn more about the services of the QR-Land smart system, please watch the videos below.",
        tutorial: "Tutorial",
        fast_food: "Fast Food",
      },
      feedback: {
        title: "Your Feedback",
        description:
          "Please answer the questions below to help us improve our services",
        question1: "How satisfied are you with our services and food quality?",
        question2: "How do you rate the variety of dishes in the restaurant?",
        question3: "How do you rate the behaviour of the restaurant staff?",
        question4: "Was the food delivered on time?",
        question5:
          "Do you have any suggestions for improving our services or food quality?",
      },
      worksheet: {
        saturday: "Saturday",
        sunday: "Sunday",
        monday: "Monday",
        tuesday: "Tuesday",
        wednesday: "Wednesday",
        thursday: "Thursday",
        friday: "Friday",
        shift_1_saturday: "10:00 to 22:00",
        shift_1_sunday: "10:00 to 22:00",
        shift_1_monday: "10:00 to 22:00",
        shift_1_tuesday: "10:00 to 22:00",
        shift_1_wednesday: "10:00 to 00:00",
        shift_1_thursday: "10:00 to 00:00",
        shift_1_friday: "10:00 to 00:00",
      },
      gallery: {
        gallery_0: "Gallery 0",
        image_1: "1",
        image_2: "2",
        image_3: "3",
        image_4: "4",
        image_5: "5",
        baked_potato_2: "Jacket Potato 2",
        chicken_stroganoff_1: "Chicken Stroganoff 1",
      },
      contact: {
        phone_1: "09999903535",
        phone_2: "02191017077",
        phone_3: "90007425",
        company_number: "02191017077",
        email: "info@qrland.ir",
        fax: "02191016066",
        location:
          "Tehran, Shariati Street, after Seyed Khandan Bridge, Khandan Cul-de-sac, No. 6, Unit 3",
        codePostal: "1541946815",
        website: "www.terminalads.com",
        address_details:
          "Iran, Tehran, Tehran City, Tehran, Tehran City District 3, Seyed Khandan Neighbourhood, Dr Ali Shariati, Khandan",
      },
    },
    messages: {
      qr_created_success: "Online menu successfully created.",
      qr_updated_success: "Your online menu QR has been successfully edited.",
      qr_create_error: "Error occurred while creating QR!",
      qr_update_error: "Error in saving/editing QR",
      template_categories_saved:
        "Sample model categories have been successfully saved.",
      template_products_saved:
        "Sample model products have been successfully saved.",
      template_categories_error: "Error saving sample model categories!",
      template_products_error: "Error saving sample model products!",
    },
    sample_menu: "Sample Menu",
    view_qr: "View QR",
    preview: "Preview",
    download_qr: "Download QR",
    create_qr: "Create QR",
    online_menu_name: "Online Menu Name",
    online_menu_name_short: "Menu Name",
    enter_qr_address: "Enter QR address",
    qr_address: "QR Address",
    enter_menu_information: "Enter menu information",
    cleardefaults: "Clear defaults",
    select_sample_menu: "Select sample menu",
    select_ready_menu: "Select ready menu",
    online_sales: "Online Sales",
    sales_settings: "Sales Settings",
    download: "Download",
    gallery_photos: "Gallery Photos",
    fast_food_1: "Fast Food Image 1",
    fast_food_2: "Fast Food Image 2",
    large_chain_fast_food: "Large Fast Food Chain",
    best_fast_food_taste_experience:
      "Experience the best fast food taste with us",
    online_menu_created_successfully: "Online menu successfully created.",
    qr_creation_failed: "Error occurred while creating QR!",
    online_menu_qr_updated_successfully:
      "Your online menu QR has been successfully edited.",
    error_saving_updating_qr: "Error in saving/editing QR",
    sample_model_categories_saved_successfully:
      "Sample model categories have been successfully saved.",
    sample_model_products_saved_successfully:
      "Sample model products have been successfully saved.",
    error_saving_sample_model_products: "Error saving sample model products!",
    error_saving_sample_model_categories:
      "Error saving sample model categories!",
  },
  editMenu: {
    enter_menu_information: "Enter menu information",
    online_menu_name: "Online Menu Name",
    online_menu_name_short: "Online Menu Short Name",
    fields: {
      qr_address_hint: "QR address for accessing the online menu",
    },
    online_sales: "Online Sales",
    sales_settings: "Sales Settings",
    shop: {
      upload_banner: "Upload Banner",
      create_product: "Create Product",
      user_info: "User Information",
      add_social_media: "Add Social Media",
      photo_gallery: "Photo Gallery",
      video_gallery: "Video Gallery",
      feedback: "Feedback",
      working_hours: "Working Hours",
    },
    success_message: "Your business card has been successfully edited.",
  },
  qrCodeSquare: {
    dots_color: "Dots Colour",
    gradient_color: "Gradient Colour",
    linear: "Linear",
    radial: "Radial",
    color_rotation: "Colour Rotation",
    first_color: "First Colour",
    second_color: "Second Colour",
    dots_color_label: "Dots Colour",
  },
  language: {
    selectAll: "Select All",
    lang: {
      fa: "Persian",
      ar: "Arabic",
      ar_ae: "Arabic (UAE)",
      ar_iq: "Arabic (Iraq)",
      en_US: "English (USA)",
      en_GB: "English (UK)",
      de: "German",
      fr: "French",
      zh_CN: "Simplified Chinese",
      zh_TW: "Traditional Chinese",
      tr: "Turkish",
      ru: "Russian",
      hy: "Armenian",
    },
    only_manual_now: "Only manual translation is available at the moment",
    ai_coming_soon: "AI translation will be activated soon",
    got_it: "Got it",
    origin_language: "Source Language",
    target_languages: "Target Languages",
    remove_all: "Remove All Languages",
    translation_method: "Choose Translation Method",
    manual_translation: "Manual Translation",
    ai_translation: "AI Translation",
    coming_soon: "Coming Soon",
    source_language_updated: "Source language updated",
    error_changing_source_language: "Error changing source language",
    source_language_created: "New source language created",
    languages_saved: "New languages saved",
    error_saving_languages: "Error saving languages",
    error_loading_language: "Error loading language",
    languages_removed: "Removed languages",
    new_languages_to_save: "New languages to save",
    saved: "Saved",
    management_langs: "Language Management",
    add_langs: "Add Language",
    change_language: "Change Language",
    visit_card: "Business Card",
    translate_to: "Translate to",
    main_language: "Language",
    no_languages_available: "No languages available",
    return_to_default: "Return to Default Language",
    translate: "Translate",
    changes_pending: "Awaiting application of changes",
    apply_changes: "Apply Changes",
    cancel_changes: "Cancel",
  },
  winner_list: "Winners List",
  qrwinnersList: {
    winnerstotalcount: "Total winners for QR",
    winnerscountoffilter: "Winners count with filter applied",
    winnersList: "QR Winners List",
    prize: "Prize",
    winnerName: "Winner Name",
    date: "Date",
    noWinners: "No winners found",
    perPage: "Items per page",
    search: "Search by winner name or prize",
    sortDirection: "Sort direction",
    sortBy: "Sort by",
  },
  appearance_settings: "Appearance settings",
  header_color: "Header colour",
  background_color: "Background colour",
  text_color: "Text colour",
  font_size: "Font size",
  chat_logo: "Chat logo",
  floating_button_icon: "Floating button icon",
  assistant_name: "Assistant name",
  chat_preview: "Chat preview",
  smart_assistant: "Smart assistant",
  online: "Online",
  aiChatSettings: {
    select_assistant: "Select Assistant",
    appearance_settings: "Appearance Settings",
    lead_connection_tab: "Lead Capture - Connect to Customer Club",

    header_settings: "Header Settings",
    header_settings_desc: "Chat header color and style",
    text_settings: "Text Settings",
    text_settings_desc: "Font color and size",
    logo_settings: "Logo Settings",
    logo_settings_desc: "Assistant photo or icon",
    background_settings: "Background Settings",
    background_settings_desc: "Background photo or color",

    gradient_color: "Gradient Color",
    solid_color: "Solid Color",
    use_image: "Use Image",
    use_icon: "Use Icon",

    first_color: "First Color",
    second_color: "Second Color",
    header_color: "Header Color",
    text_color: "Text Color",
    background_color: "Background Color",

    font_size: "Font Size",

    robot: "Robot",
    chat: "Chat",
    support: "Support",
    question: "Question",
    message: "Message",
    assistant_voice: "Assistant",
    ai_brain: "Artificial Intelligence",

    lead_connection_title: "Connect to Customer Club",
    lead_alert:
      "Setting these options will save the user's information in the Customer Club when they choose to submit a lead.",

    hasAssistantsName_label: "Capture Name",
    hasAssistantsName_hint: "Collect user's name",
    hasAssistantsFamily_label: "Capture Family Name",
    hasAssistantsFamily_hint: "Collect user's family name",
    hasAssistantsMobile_label: "Capture Mobile Number",
    hasAssistantsMobile_hint: "Collect user's mobile number",
  },
  assistantChatViewer: {
    assistant_name: "Smart Assistant",
    online: "Online",
    new_chat: "New Chat",
    clear_chat: "Clear Chat",
    close: "Close",
    message_placeholder: "Message...",
    processing: "Processing...",
    renew: "Renew",
    created_at: "Created at",
    last_edit: "Last edited",
    copied: "Copied",
    copy: "Copy",
    print_qr: "Print QR",
    print_visit_card: "Print Visit Card",
    send_link: "Send Link",
    winner_list: "Winner List",
    customer_list: "Customer List",
    order_list: "Order List",
    reserved_appointments: "Reserved Appointments",
    feedback: "Feedback",
    request_form: "Request Form",
    transfer_ownership: "Transfer Ownership",
    store_management: "Store Management",
    select_nfc_card: "Select NFC Card",
    edit: "Edit",
    design: "Design",
    qr_settings: "QR Settings",
    deactivate: "Deactivate",
    download: "Download",
    viewed: "Viewed times",
    see_more: "See more",
    updating_qr: "Updating QR...",
  },

  create_game: "Create Game",
  ready_games: "Ready Games",
  add_game: "Add Game",
  game_gallery: "Game Gallery",
  game_tab: "Game",
  game_size_error: "Game file size must not exceed 2MB",
  game_upload_error: "Game upload error",
  no_game_available: "No games available",
  to_use_ready_games_search_category_or_product:
    "To use ready games, search for category or product",
  create_gif: "Create Gif",
  ready_gifs: "Ready gifs",
  add_gif: "Add Gif",
  gif_gallery: "Gif Gallery",
  gif_tab: "Gif",
  select_gif: "Select Gif",
  show_gif: "Show Gif",
  gif_size_error: "Gif file size must not exceed 2MB",
  gif_upload_error: "Gif upload error",
  no_gif_available: "No gif available",
  to_use_ready_gifs_search_category_or_product:
    "To use ready gifs, search for category or product",
  no_gif_found: "No gif found",
  to_use_external_gif_link_fill_fields: "To use external gif link, fill fields",
  gif_url_hint: "Enter Gif URL here",
  gif_url: "Gif URL",
  create_gif: "Create Gif",
  ready_gifs: "Ready Gifs",
  gif_gallery: "Gif Gallery",
  edit_gif: "Edit Gif",
  max_background_gif_size_2mb: "Max background gif size 2MB",
  gif_upload_error: "Gif upload error",
  welcome_gif_upload: "Gif Upload",
  previewer_page: "Preview Page",
  create_game: "Create Game",
  ready_games: "Ready Games",
  add_game: "Add Game",
  game_gallery: "Game Gallery",
  game_size_error: "Game file size must not exceed 2MB",
  game_upload_error: "Error uploading game",
  no_game_available: "No games available",
  to_use_ready_games_search_category_or_product:
    "To use ready games, search by category or product",
  gif_size_error: "GIF file size must not exceed 2MB",
  previewer_page: "Preview Display",
  // ─────────────────────────────────────────────────────
  // Translation keys for game, gif and settings section
  // File: src/core/services/langs/en_GB.js
  // British English version
  // ─────────────────────────────────────────────────────
  // ══════════════════════════════════════════════════════
  // 1. Main Game Editor (PublicGameEditor)
  // ══════════════════════════════════════════════════════
  game_editor: "Game Editor",
  reset_defaults: "Reset to Defaults",
  save_and_preview: "Save and Preview",
  texts: "Texts",
  images: "Images",
  colors: "Colours",
  general_settings: "General Settings",
  gameplay_settings: "Gameplay Settings",
  effects: "Effects",
  login_and_phone: "Login and Phone Number",
  no_settings_available_for_this_game_type:
    "No settings available for this game type",
  confirm_reset: "Confirm Reset",
  reset_all_settings_to_default:
    "Are you sure you want to reset all settings to default?",
  yes_reset: "Yes, Reset",
  cancel: "Cancel",
  settings_reset_successfully: "Settings reset successfully",
  saved_and_ready_for_preview: "Saved and ready for preview",

  // ══════════════════════════════════════════════════════
  // 2. Login & Phone Tab (TabLogin)
  // ══════════════════════════════════════════════════════
  login_and_phone_settings: "Login and Phone Settings",
  ask_phone_after_game: "Request Phone Number After Game",
  phone_prompt_text: "Phone Number Prompt Text",
  phone_prompt_hint: "The text shown in the phone number request dialogue",
  submit_button: "Submit Button",
  login_dialog_logo: "Login Dialogue Logo",
  logo_url: "Logo URL",

  // ══════════════════════════════════════════════════════
  // 3. Effects Tab (TabEffect)
  // ══════════════════════════════════════════════════════
  game_effects_settings: "Game Effects Settings",
  sound_enabled: "Enable Sound",
  volume: "Volume",
  volume_hint: "Game sound volume level (0 to 1)",
  oscillator_type: "Oscillator Type",
  jump_sound_freq: "Jump Sound Frequency",
  hit_sound_freq: "Hit Sound Frequency",
  powerup_sound_freq: "Powerup Sound Frequency",
  move_sound_freq: "Move Sound Frequency",
  combo_base_freq: "Combo Base Frequency",
  sound_durations: "Sound Durations",
  move_duration_ms: "Move Sound Duration (ms)",
  jump_duration_ms: "Jump Sound Duration (ms)",
  combo_duration_ms: "Combo Sound Duration (ms)",
  hit_duration_ms: "Hit Sound Duration (ms)",
  vibration_enabled: "Enable Vibration",
  particles_enabled: "Enable Particles",
  explosion_settings: "Explosion Particles Settings",
  particle_count: "Particle Count",
  gravity: "Gravity",
  friction: "Friction",
  fade_speed: "Fade Speed",

  // ══════════════════════════════════════════════════════
  // 4. Images Tab (TabImages)
  // ══════════════════════════════════════════════════════
  game_images_and_assets: "Game Images & Assets",
  player_image: "Player Image",
  player: "Player",
  powerup_image: "Powerup Image",
  qr_powerup: "QR Powerup",
  enemy_images: "Enemy Images",
  optional_multi: "Optional, multiple images",
  enemies: "Enemies",
  background_image: "Background Image",
  background: "Background",
  phone_frame_background: "Phone Frame Background",
  phone_frame: "Phone Frame",
  winner_background: "Winner Background",
  winner: "Winner",
  ground_image: "Ground Image",
  ground: "Ground",
  player_character: "Player Character",
  far_background_layer: "Far Background Layer",
  background_far: "Far Background",
  near_background_layer: "Near Background Layer",
  background_near: "Near Background",
  obstacle_images: "Obstacle Images",
  multi_optional: "Multiple images, optional",
  obstacles: "Obstacles",

  // ══════════════════════════════════════════════════════
  // 5. Texts Tab (TabTexts)
  // ══════════════════════════════════════════════════════
  game_text_contents: "Game Text Content",
  main_screen_texts: "Main Screen Texts",
  game_title: "Game Title",
  game_subtitle: "Game Subtitle",
  start_button: "Start Button",
  score_label: "Score Label",
  game_over_screen: "Game Over Screen",
  game_over_title: "Game Over Title",
  game_over_subtitle: "Game Over Subtitle",
  phone_prompt: "Phone Number Prompt",
  restart_button: "Restart Button",
  hud_and_labels: "HUD & Labels",
  level_label: "Level Label",
  combo_label: "Combo Label",
  final_score_label: "Final Score Label",
  high_score_label: "High Score Label",
  messages_and_popups: "Messages & Popups",
  new_record_message: "New Record Message",
  fun_random_messages: "Fun Random Messages",
  add_new_message: "Add New Message",

  // ══════════════════════════════════════════════════════
  // 6. General Settings Tab (TabSetting)
  // ══════════════════════════════════════════════════════
  general_game_settings: "General Game Settings",
  enemy_spawn_rate: "Enemy Spawn Rate",
  frames_between_enemies_spawn: "Frames Between Enemy Spawns",
  powerup_spawn_rate: "Powerup Spawn Rate",
  frames_between_qr_spawn: "Frames Between QR Spawns",
  win_score_threshold: "Win Score Threshold",
  score_required_for_win_or_phone_prompt:
    "Score required for win or phone prompt",
  starting_lives: "Starting Lives",
  high_score_storage_key: "High Score Storage Key",
  phone_prompt_score_threshold: "Phone Prompt Score Threshold",
  score_to_show_phone_number_form: "Score to show phone number form",
  no_general_settings_available_for_this_game:
    "No general settings available for this game",

  // ══════════════════════════════════════════════════════
  // 7. Gameplay Tab (TabGamePlay)
  // ══════════════════════════════════════════════════════
  speed_settings: "Speed Settings",
  initial_speed: "Initial Speed",
  max_speed: "Max Speed",
  speed_increase_every_frames: "Increase Speed Every Frames",
  speed_increase_amount: "Speed Increase Amount",
  distance_per_level: "Distance Per Level",
  level_speed_increase: "Level Speed Increase",
  jump_and_physics: "Jump & Physics",
  jump_force: "Jump Force",
  max_jump_height: "Max Jump Height",
  lanes_settings: "Lanes Settings",
  number_of_lanes: "Number of Lanes",
  starting_lane: "Starting Lane",
  enemies_spawn: "Enemies Spawn",
  traps_spawn: "Traps Spawn",
  min_spawn_interval_ms: "Min Spawn Interval (ms)",
  max_spawn_interval_ms: "Max Spawn Interval (ms)",
  same_lane_chance: "Same Lane Chance",
  probability_of_spawn_in_player_lane: "Probability of Spawn in Player Lane",
  collision_tolerance_px: "Collision Tolerance (px)",
  scoring_rules: "Scoring Rules",
  hit_penalty: "Hit Penalty",
  powerup_reward: "Powerup Reward",
  score_speed_divider: "Score Speed Divider",
  reset_combo_on_hit: "Reset Combo on Hit",
  camera_settings: "Camera Settings",
  normal_zoom: "Normal Zoom",
  hit_zoom: "Hit Zoom",
  zoom_lerp_speed: "Zoom Lerp Speed",
  game_end_conditions: "Game End Conditions",
  phone_dialog_score_threshold: "Phone Dialogue Score Threshold",

  // ══════════════════════════════════════════════════════
  // 8. Colors Tab (TabColors)
  // ══════════════════════════════════════════════════════
  background_gradient: "Background Gradient",
  first_color: "First Colour",
  second_color: "Second Colour",
  particle_hit_color: "Hit Particle Colour",
  particle_powerup_color: "Powerup Particle Colour",
  main_background_color: "Main Background Colour",
  ground_color: "Ground Colour",
  hud_colors: "HUD Colours",
  hud_background: "HUD Background",
  score_text_color: "Score Text Colour",
  level_text_color: "Level Text Colour",
  combo_text_color: "Combo Text Colour",
  overlay_colors: "Overlay Colours",
  backdrop_color: "Backdrop Colour",
  card_background: "Card Background",
  card_border_color: "Card Border Colour",
  explosion_particle_color: "Explosion Particle Colour",

  // ══════════════════════════════════════════════════════
  // 9. QR Previewer Component (previewerQr)
  // ══════════════════════════════════════════════════════
  gif_tab: "GIF Tab",
  game_tab: "Game Tab",
  welcome_gif_upload: "Upload Welcome GIF",
  default_welcome: "Default Welcome",
  loading_animation: "Loading Animation",
  hide_previewer: "Hide Previewer",
  show_previewer: "Show Previewer",
  edit_game_settings: "Edit Game Settings",
  save_and_close: "Save and Close",
  animation_scale: "Animation Scale",
  animation_slide_x: "Horizontal Slide Animation",
  animation_slide_y: "Vertical Slide Animation",
  animation_fade: "Fade Animation",
  game_settings_saved: "Game settings saved",
  no_game_configured: "No game configured",

  // ══════════════════════════════════════════════════════
  // 10. GIF Selector (gifSelector)
  // ══════════════════════════════════════════════════════
  gallery_name: "Gallery Name",
  change_gallery_name: "Change Gallery Name",
  add_gif: "Add GIF",
  select_gif: "Select GIF",
  show_gif: "Show GIF",
  selected_gif: "Selected GIF",
  count: "Count",
  select_category: "Select Category",
  after_typing_enter: "After typing, press Enter",
  search: "Search",
  no_gif_available: "No GIF available",
  to_use_ready_gifs_search_category_or_product:
    "To use ready-made GIFs, search by category or product",
  max_file_size_2mb: "Maximum file size 2MB",
  upload_file: "Upload File",
  drag_and_drop_to_upload_or: "Drag and drop to upload or",
  here: "here",
  click: "click",
  all: "All",
  no_gif_found: "No GIF found",
  for_adding_file_use_upload_center: "To add a file, use the upload centre",
  to_use_external_gif_link_fill_fields:
    "To use an external GIF link, fill in the fields",
  gif_url_hint: "Full GIF file URL",
  gif_url: "GIF URL",
  add: "Add",
  title: "Title",
  link: "Link",
  description: "Description",
  add_new_gallery: "Add New Gallery",
  enter_valid_link: "Enter a valid link",
  create_gif: "Create GIF",
  ready_gifs: "Ready GIFs",
  gif_gallery: "GIF Gallery",
  edit_gif: "Edit GIF",
  max_background_gif_size_2mb: "Maximum background GIF size is 2MB",
  uploaded_successfully: "Uploaded successfully",
  gif_upload_error: "GIF upload error",

  // ══════════════════════════════════════════════════════
  // 11. Extra texts and other test keys
  // ══════════════════════════════════════════════════════
  preview: "Preview",
  start_button_text: "Start Button Text",
  game_over_text: "Game Over Text",
  game_over_subtext: "Game Over Subtext",
  mobile_prompt_text: "Mobile Prompt Text",
  submit_button_text: "Submit Button Text",
  optional: "Optional",
  game_background: "Game Background",
  background_gradient_colors: "Background Gradient Colours",
  frames_per_enemy: "Frames per Enemy",
  frames_per_powerup: "Frames per Powerup",
  win_threshold: "Win Threshold",
  score_to_win: "Score to Win",
  your_work_page_name: "Personal/Corporate Kiwvar",
  "pdf_gallery": {
    "display_mode": "PDF Gallery Display Mode",
    "display_mode_label": "Display Mode",
    "layout": {
      "list": "List View",
      "accordion": "Accordion View",
      "slider": "Slider View"
    },
    "gallery_name": "Gallery Name",
    "selected_gallery": "Selected Gallery",
    "add_file": "Add File",
    "pdf_gallery_label": "PDF Gallery",
    "select_file": "Select File",
    "title": "Title",
    "pdf_url": "PDF URL",
    "description": "Description",
    "add_button": "Add",
    "all": "All",
    "image_gallery": "Image Gallery",
    "edit_pdf": "Edit PDF",
    "preview": "Preview",
    "add_pdf_gallery": "Add PDF Gallery",
    "default_gallery_name": "Gallery",
    "gallery_prefix": "Gallery",
    "tabs": {
      "add_file": "Add File",
      "pdf_gallery": "PDF Gallery",
      "link": "Link"
    },
    "messages": {
      "file_too_large": "File size cannot exceed 10 MB.",
      "invalid_file_type": "Please select only document and text files.",
      "upload_error": "Error uploading file.",
      "only_pdf_txt_allowed": "Only PDF and TXT files can be added.",
      "title_url_required": "Please enter the title and file URL."
    }
  },
  "special_info_desc": {
    "textCards": "Add text cards to display user information such as descriptions, background, or a short bio.",
    "customerClubSettings": "Set the customer club membership message sent to users after registering their number.",
    "advanceSettings": "Manage advanced and smart settings to customize page behavior and features.",
    "voiceGallery": "Upload and manage audio files to play on the page.",
    "VideoGallery": "Add and display videos for introduction, training, or content display.",
    "imageUploader": "Upload images to display in the gallery or different parts of the page.",
    "colorPallete": "Select custom colors to personalize the page design and appearance.",
    "socialMediaIcons": "Add social media links for quick user access.",
    "pdfSelector": "Upload and display PDF files for users to view or download.",
    "FeedBack": "Receive user comments and feedback about services or content.",
    "consultationNew": "Create a form for users to submit requests, get consultation, or contact."
  },
  "voice_gallery": {
    "autoplay_warning": "You can only set one audio file to autoplay at a time.",
    "autoplay": "Autoplay"
  },
  "card": {
    "consultation": {
      "title": "Request Form"
    },
    "form": {
      "name": "First Name",
      "surname": "Last Name",
      "phone": "Mobile Number",
      "email": "Email",
      "address": "Address",
      "national_id": "National ID",
      "location": "Location",
      "description": "Description"
    },
    "feedback": {
      "title": "Your Feedback",
      "description": "Please help us improve our services by answering the following questions:",
      "q1": "How satisfied are you with QRLand services?",
      "q2": "To what extent have QRLand services covered your needs?",
      "q3": "How reasonable was the cost paid for the received service?",
      "q4": "Share your thoughts with us to improve our services."
    },
    "pdf": {
      "gallery_name": "QRLand Proposals Gallery",
      "item1_title": "Product Introduction Proposal",
      "item1_desc": "Comprehensive introduction to QRLand services, how smart QR codes work, benefits for businesses, and use cases to increase customer engagement.",
      "item2_title": "Digital Business Card Proposal",
      "item2_desc": "Introduction to QRLand digital business card, features for quick sharing of contact info, social media links, and professional CRM."
    },
    "pdf_selector": {
      "title": "PDF Gallery",
      "description": "Description"
    },
    "info": {
      "visit_name": "QRLand / Digital Business Card",
      "organization_name": "QRLand",
      "sub_organ": "The First Dynamic QR Generator Platform",
      "user_name": "Digital Business Card",
      "fax": "Fax: 02191016066",
      "location_desc": "No. 6, Khandan Alley, after Seyed Khandan Bridge, Shariati St., Tehran",
      "postal_code": "Postal Code: 1541946815",
      "about_us": "Due to the problems with physical business cards, the QRLand platform has introduced a product called 'Digital Business Card'. Using digital technologies, it has completely eliminated the limitations of physical business cards. Simultaneously, by switching to smart alternatives, prevent excessive tree cutting.",
      "full_address": "Khandan, Dr. Ali Shariati, Seyed Khandan neighborhood, District 3, Tehran, Tehran Province, Iran"
    },
    "extra": {
      "field1": "🟥 Create a similar digital business card for your own business.\n🟧 Test it for free for 3 days.\n🟨 Click here to register for free.",
      "field2": "Your digital business card features a dynamic QR code. You can edit the information at any time via your mobile phone. Your QR code will never change after editing.",
      "field3": "💲 The cost of having this business card is 900,000 Tomans."
    },
    "gallery": {
      "name": "We will always stand by you..."
    },
    "social": {
      "address_hint": "Please enter your address",
      "address_label": "Address",
      "instagram_hint": "Please enter your Instagram URL",
      "instagram_label": "Instagram",
      "whatsapp_hint": "Please enter your WhatsApp URL",
      "whatsapp_label": "WhatsApp"
    },
    "video": {
      "item1_name": "Why QRLand Business Card? What makes QRLand different?",
      "item1_title": "Why QRLand Business Card",
      "item2_name": "Introduction to QRLand Digital Business Card",
      "item2_title": "The Best Alternative to Physical Business Cards"
    },
    "club": {
      "title": "Customer Club Membership",
      "description": "This is not an ordinary customer club!\nRegister your number"
    },
    "audio": {
      "category_all": "All",
      "item1_title": "Comprehensive Guide to Digital Business Cards",
      "diff_seconds": "1 second ago"
    }
  },
  "pic": {
    "background_image": "Background Image",
    "image_display_type": "Image Display Type",
    "image_orientation": "Image Orientation:",
    "horizontal": "Horizontal",
    "vertical": "Vertical",
    "change_display_mode": "Change Display Mode",
    "image": "Image",
    "uploaded_image": "Uploaded Image"
  },
  "send_limit_per_user": "Sending limit per user (0 = Unlimited)",
  "enable_discount_code": "Enable discount code",
  "add_new_discount_code": "Add new discount code",
  "no_discount_codes_added": "No discount codes have been added",

  "toolsManagment": "Management Tools",
"gateway": {
  "edit": "Edit",
  "integrated_edit_all_sections": "Integrated edit of all sections",
  "show_descriptions": "Show descriptions",
  "search_section_placeholder": "Search for a section...",
  "no_section_found": "No section found with this name.",
  "back_to_menu": "Back to menu",
  "cancel": "Cancel",
  "save": "Save"
},
"gridShow": "Grid View",
"tableShow": "Table View",
"editvisit": {
  special_info_single: {
    text_cards_description:
      "Add text cards to display user information such as descriptions, experience, or a short introduction.",

    customer_club_settings_description:
      "Set the customer club membership message that is sent to users after they register their phone number.",

    advance_settings_description:
      "Manage advanced and smart settings to customise the page's behaviour and features.",

    voice_gallery_description:
      "Upload and manage audio files to be played on the page.",

    video_gallery_description:
      "Add and display videos for introduction, training, or content presentation.",

    image_uploader_description:
      "Upload images to display in the gallery or different sections of the page.",

    color_palette_description:
      "Choose custom colours to personalise the page's appearance and design.",

    social_media_icons_description:
      "Add social media links for quick access.",
  },
},

"editBpage": {
  special_info_single: {
    banner_selector_description:
      "Upload or change the main banner image of the complex.",

    logo_select_description:
      "Set the logo of the business or complex.",

    service_description:
      "Manage the main services and facilities of the complex.",

    faq_description:
      "Add and edit frequently asked questions from customers.",

    blog_description:
      "Add articles and news related to the complex.",

    floor_description:
      "Manage the floors and retail units of the complex.",

    text_cards_description:
      "Enter descriptions and user-related information.",

    social_media_icons_description:
      "Add social media links for customer communication.",

    pic_selector_description:
      "Add images of the complex and stores.",

    video_gallery_description:
      "Upload promotional or introductory videos.",

    pdf_selector_description:
      "Manage catalogues and informational guide files.",

    feedback_description:
      "Manage the visitor feedback and reviews section.",

    consultation_new_description:
      "Manage the form for collecting customer information or requests.",

    service_section_description:
      "Create dedicated service sections.",

    counter_service_description:
      "Display the complex's statistics and achievements numerically.",

    counter_description:
      "Set a countdown for events or the opening.",

    personnel_description:
      "Introduce managers and key team members.",

    customer_club_settings_description:
      "Manage SMS and customer club registration settings.",

    work_sheet_description:
      "Specify the working hours and operating days of the complex.",

    pallet_commercial_description:
      "Set the page's colours and visual style.",

    default_description:
      "Add and manage the {title} section on the business page.",
  },
},

store_special_info_single: {
  shop_login_config_description:
    "Configure the login page and change the store logo.",

  banner_selector_description:
    "Upload and manage store banners.",

  text_cards_description:
    "Text information, introduction, and about us.",

  product_description:
    "Create, manage, and edit products.",

  special_category_manager_description:
    "Manage categories for special offers and discounted products.",

  social_media_icons_description:
    "Add social media links for the store.",

  blog_description:
    "Write and manage blog posts.",

  service_description:
    "Introduce additional services provided.",

  faq_description:
    "Display and manage the list of frequently asked questions.",

  pic_selector_description:
    "Upload and manage the store image gallery.",

  video_gallery_description:
    "Upload promotional and introductory videos.",

  pdf_selector_description:
    "Provide guide files or PDF catalogues.",

  feedback_description:
    "Manage customer reviews and feedback.",

  counter_description:
    "Set a countdown for events or special offers.",

  consultation_description:
    "Create a form for receiving requests or consultation enquiries.",

  service_section_description:
    "Manage dedicated service sections.",

  counter_service_description:
    "Display the store's statistics, figures, and achievements.",

  personnel_description:
    "Introduce team members and store staff.",

  work_sheet_description:
    "Set the store's working days and hours.",

  default_description:
    "Add and manage the {title} section on the store page.",
},
edit_gold_special_info_single: {
  product_info_title: "Product Information",
  product_info_description:
    "Add and edit the main product details, features, price, and additional descriptions.",

  asset_management_title: "Asset Management",
  asset_management_description:
    "Manage assets, assign values, and manage wallet information related to the product.",

  add_social_networks_title: "Add Social Networks",
  social_networks_title: "Social Networks",
  social_media_description:
    "Add social media links so customers can connect with your brand more easily.",

  add_video_title: "Add Video",
  video_description:
    "Add and display product introduction, educational, or promotional videos.",

  add_image_title: "Add Image",
  image_description:
    "Upload high-quality product images from different angles for a better gallery presentation.",

  select_color_title: "Select Colour",
  color_palette_description:
    "Customise the product display page's colour scheme and appearance to match your brand identity.",
},

edit_multicard_special_info_single: {
  add_account_description:
    "Edit the name, profile picture, and background",

  management_account_description:
    "Add and edit bank account information",

  management_color_description:
    "Change the colour theme of buttons and background",
},

edit_feedback_special_single: {
  base_info_description:
    "Edit the basic information and form title",

  image_uploader_description:
    "Upload and manage the feedback form logo",

  feedback_description:
    "Configure fields and manage the feedback form",

  color_palette_description:
    "Select a colour theme and customise the form appearance",
},

edit_gitf_special_info_single: {
  default_description:
    "Add and manage the {title} section in the Memories QR frame.",
},

edit_catalog_special_info_single: {
  text_cards_description:
    "Basic information, title, and catalogue description",

  image_uploader_description:
    "Upload and manage the logo or main image",

  pic_selector_description:
    "Upload and manage catalogue or brochure pages",

  social_media_icons_description:
    "Add and manage social media links",

  color_palette_description:
    "Select a colour theme and customise the appearance",
},

edit_menu_special_info_single: {
  theme_selector_description:
    "Select a template to apply a different categorisation",

  login_config_description:
    "Login page settings and appearance",

  general_settings_description:
    "General settings for your currency and business type.",

  banner_selector_description:
    "Upload and select a banner image to display at the top of the page and make the menu or profile more attractive.",

  product_description:
    "Create and manage products or services with details such as images, prices, and custom descriptions.",

  text_cards_description:
    "Add text cards to display basic user information such as general descriptions, experience, or a short introduction.",

  social_media_description:
    "Add social media links and icons for faster communication and easier customer access.",

  photo_gallery_description:
    "Create an image gallery to display product photos, portfolios, or your business environment.",

  video_gallery_description:
    "Add a video gallery for promotional clips, educational videos, or introductions.",

  feedback_description:
    "Create a section to display customer reviews, feedback, and previous customer satisfaction.",

  working_hours_description:
    "Set your working hours and business operating times.",
},

edit_pdf_special_info_single: {
  base_info_title: "Information",
  base_info_description:
    "Add text cards to display basic user information such as general descriptions, experience, or a short introduction.",

  image_uploader_title: "Upload Logo",
  image_uploader_description:
    "Upload and select an image to use as the logo or profile picture displayed on the page.",

  pdf_selector_title: "Add PDF Gallery",
  pdf_selector_description:
    "Create a gallery of PDF or text files, with the option to add a cover image and a custom description for each file.",

  social_media_icons_title: "Add Social Networks",
  social_media_icons_description:
    "Add social media links and icons for faster communication and easier access.",

  color_palette_title: "Select Colour",
  color_palette_description:
    "Select the theme colour and customise the appearance of elements to better match your brand.",
},

edi_photogallery_spcial_info_single: {
  default_description:
    "Add and manage the {title} section in the photo gallery.",
},

edi_social_special_info_single: {
  banner_selector_title: "Upload Photo",
  banner_selector_description:
    "Select and upload a background image or banner for the top of your social media page.",

  base_info_title: "Information",
  base_info_description:
    "Enter basic information such as the main title and your profile description.",

  image_uploader_title: "Upload Logo",
  image_uploader_description:
    "Upload your personal or brand logo or profile image to display on the page.",

  social_media_icons_title: "Add Social Networks",
  social_media_icons_description:
    "Add links to social networks such as Instagram, Telegram, WhatsApp, LinkedIn, and others so their icons appear on the page.",
},

edit_text_special_info_single: {
  base_info_title: "QR Information and Texts",
  base_info_subtitle: "Main Text and Text Fields",
  base_info_description:
    "Edit the title, main About Us text, and custom QR text fields",

  image_uploader_title: "Logo and Background Image",
  image_uploader_subtitle: "Image Settings",
  image_uploader_description:
    "Upload and change the custom logo or card background image",

  color_palette_subtitle: "Customise Appearance",
  color_palette_description:
    "Set header, background, and text colours to improve readability and contrast",
},

edit_video_special_info_single: {
  base_info_title: "Information",
  base_info_description:
    "Edit basic information such as the title and QR code address.",

  image_uploader_title: "Upload Logo",
  image_uploader_description:
    "Upload and manage the page logo image.",

  video_gallery_title: "Video Gallery",
  video_gallery_description:
    "Add, edit, and manage videos to be displayed in the gallery.",

  social_media_icons_title: "Add Social Networks",
  social_media_icons_description:
    "Add social media links and contact methods.",

  color_palette_title: "Select Colour",
  color_palette_description:
    "Change the colour scheme and select a suitable colour theme for the page.",
},

edit_product_special_info_single: {
  factory_info_description:
    "Edit the company information and introduction",

  single_product_editor_description:
    "Edit the main details and call-to-action buttons such as Purchase",

  customer_club_settings_description:
    "Customer club settings and SMS messaging",

  advance_settings_description:
    "Advanced display and security settings",

  features_description:
    "Manage product features and technical specifications",

  voice_gallery_description:
    "Upload and manage podcasts and audio files",

  image_uploader_description:
    "Upload and manage the product image gallery",

  video_gallery_description:
    "Add and manage the related product video gallery",

  social_media_icons_description:
    "Add and manage social media links",

  color_palette_description:
    "Select a colour theme and customise the template",
},

edit_product_pro_special_info_single: {
  factory_info_description:
    "Enter general information and introduce the production company.",

  single_product_editor_description:
    "Set the main information, trust badge, and product purchase button.",

  customer_club_settings_description:
    "SMS settings and customer membership in the club.",

  features_description:
    "Add product features and technical specifications.",

  feedback_description:
    "Buyer reviews and feedback section.",

  consultation_description:
    "Consultation request or order form.",

  advance_settings_description:
    "Advanced and smart product display settings.",

  voice_gallery_description:
    "Audio files for product introductions or guides.",

  image_uploader_description:
    "Upload different product images.",

  video_gallery_description:
    "Related product introduction or educational videos.",

  social_media_icons_description:
    "Social media links for better communication.",

  color_palette_description:
    "Set the colours and visual style of the product page.",
},

edit_voice_special_info_single: {
  base_info_voice_description:
    "Basic information and audio gallery details",

  image_uploader_description:
    "Upload and manage the logo or cover image",

  voice_gallery_description:
    "Upload and manage audio files and podcasts",

  color_palette_description:
    "Select a colour theme and customise the gallery appearance",
},

edit_voice_pro_special_info_single: {
  base_info_description:
    "Edit the gallery title and description",

  image_uploader_description:
    "Upload and manage the logo and main cover",

  voice_gallery_acc_description:
    "Upload, delete, and manage audio files",

  social_media_icons_description:
    "Add and manage social media links",

  color_palette_description:
    "Select a colour theme and customise the gallery appearance",
},
edit_bpage_special_info_special: {
  advertising_sites: "Advertising sites",
stores: "Stores",

divar: "Divar",
divar_hint: "Enter your Divar link",

sheypoor: "Sheypoor",
sheypoor_hint: "Enter your Sheypoor link",

digikala: "Digikala",
digikala_hint: "Enter your Digikala link",

basalam: "Basalam",
basalam_hint: "Enter your Basalam link",

snappshop: "SnappShop",
snappshop_hint: "Enter your SnappShop link",

technolife: "Technolife",
technolife_hint: "Enter your Technolife link",

torob: "Torob",
torob_hint: "Enter your Torob link",

emalls: "eMalls",
emalls_hint: "Enter your eMalls link",

cafebazaar: "Cafe Bazaar",
cafebazaar_hint: "Enter your Cafe Bazaar link",

googleplay: "Google Play",
googleplay_hint: "Enter your Google Play link",

samsung: "Samsung",
samsung_hint: "Enter your Galaxy Store link",

apple: "Apple",
apple_hint: "Enter your App Store link",
  add_audio_gallery: "Add audio file gallery",
  factory_information: "Business information",
  trust_badge: "Trust badge",
  buy_button: "Buy button",
  smart_settings: "Smart settings",
  add_product_feature: "Add product feature",
  product_features: "Product features",
  add_audio_file: "Add audio file",
  audio_gallery: "Audio gallery",
  text: "Text",
  logo_background: "Logo / background",
  select_color: "Select colour",
  information: "Information",
  luck_management: "Luck management",
  registration_management: "Registration management",
  turning: "Turning",
  slider: "Slider",
  vertical: "Vertical",
  upload_catalog_brochure_images: "Upload catalogue / brochure images",
  upload_banner: "Upload banner",
  upload_header_image: "Upload header image",
  upload_image: "Upload image",
  services: "Services",
  faq: "Frequently asked questions",
  blog: "Blog",
  create_product: "Create product",
  user_information: "User information",
  add_social_media: "Add social media",
  photo_gallery: "Photo gallery",
  video_gallery: "Video gallery",
  pdf_gallery: "PDF gallery",
  feedback: "Feedback",
  request_form: "Request form",
  create_section: "Create section",
  achievements: "Achievements",
  countdown: "Countdown",
  team_members: "Team members",
  working_hours: "Working hours",
  upload_logo: "Upload logo",
  create_store: "Create store",
  customer_club_membership_sms: "Customer club membership SMS",
  product_information: "Product information",
  asset_management: "Asset management",
  social_media: "Social media",
  add_video: "Add video",
  add_image: "Add image",
  add_user_information: "Add user information",
  manage_accounts: "Manage accounts",
  manage_color: "Manage colours",
  download_qr: "Download QR code",
  add_store: "Add store",
  manage_appointments: "Manage appointments",
},
edit_gift_special_info_special: {
  gift_story: "Gift story",
  profile_image: "Profile image",
  featured_images: "Featured images",
  image_gallery: "Image gallery",
  video_gallery: "Video gallery",
  add_audio_file: "Add audio file",
  select_color: "Select colour",
},
edit_insurance_special_info_special: {
  login_settings: "Login settings",
  shop_logo_images: "Shop logo and images",
  login_page_information: "Login page information",
  upload_banner_logo: "Upload banner and logo",
  user_information: "User information",
  manage_products_insurance: "Manage products / insurance",
  special_sale: "Special sale",
  add_social_media: "Add social media",
  blog: "Blog",
  services: "Services",
  faq: "Frequently asked questions",
  photo_gallery: "Photo gallery",
  video_gallery: "Video gallery",
  pdf_gallery: "PDF gallery",
  feedback: "Feedback",
  countdown: "Countdown",
  request_form: "Request form",
  create_section: "Create section",
  achievements: "Achievements",
  team_members: "Team members",
  working_hours: "Working hours",
  shop_login_description: "Shop logo and login page settings",
  insurance_manage_description: "Add and edit the list of products / services",
  banner_description: "Manage header images",
},
};
